import React, { useState } from 'react';
import { Clock, Activity, ShieldCheck, TrendingUp, Zap, Box, Gauge, ArrowLeftRight, Target, BarChart2, Stethoscope, Calendar, TrendingDown, Users, User, ThumbsUp, ThumbsDown, AlertTriangle, Ban, Info, Bot } from 'lucide-react';
import { useCalculationsSelector } from '../store/selectors/calculations';
import { evaluateRentabilitaet } from '../store/utils'; // 💉 CHIRURGIE: Doppel-Schloss Import

// 💉 KORRIGIERTER IMPORT
import CockpitAiModal from '../components/CockpitAiModal';
import { TeamBonusPreviewPanel } from '../components/teamBonus';
import { useTeamBonus } from '../store/hooks/useTeamBonus';

// ============================================================================
// STYLES: EXECUTIVE CARBON EDITION
// ============================================================================
const DashboardStyles = () => (
    <style>{`
        @import url('https://fonts.googleapis.com/css2?family=JetBrains+Mono:wght@400;700;800&family=Inter:wght@300;400;600;800&display=swap');

        .font-sans { font-family: 'Inter', sans-serif; }
        .font-mono-numbers { font-family: 'JetBrains Mono', monospace; font-variant-numeric: tabular-nums; }
        
                .bg-deep-space { background-color: #030303; }
        html:not(.dark) .bg-deep-space { background-color: var(--pe-bg-primary); }
        .text-phantom-gold { color: #E6C299; }
        
        .carbon-console, .carbon-panel {
            position: relative;
            border-radius: 1.5rem;
            border: 1px solid #2a2a2a;
            box-shadow: 0 30px 60px -15px rgba(0,0,0,1), inset 0 2px 5px rgba(255,255,255,0.05);
            background-color: #030303;
        }
        
        .carbon-console { border-top: 1px solid #444; margin-bottom: 2.5rem; }
        .carbon-console--split { padding: 0; overflow: hidden; }
        .carbon-console__head { padding: 1.5rem 2rem; }
        .carbon-console__body { padding: 2.5rem 2rem; background-color: #030303; }
        .carbon-panel--split { padding: 0; overflow: hidden; }
        .carbon-panel__head { padding: 1.5rem 2rem; }
        .carbon-panel__body { padding: 2rem; background-color: #030303; }
        @media (min-width: 1024px) {
            .carbon-panel__head { padding: 2rem 2.5rem; }
            .carbon-panel__body { padding: 2.5rem; }
        }

        .carbon-console::after, .carbon-panel::after {
            content: ''; position: absolute; inset: 0; background: linear-gradient(to bottom, transparent, rgba(0,0,0,0.6)); border-radius: inherit; pointer-events: none;
        }

        .carbon-content { position: relative; z-index: 10; }

        html:not(.dark) .carbon-weave-bg { background-color: var(--pe-bg-elevated); background-image: none; }

        /* Light Mode: Carbon → Warm Platin, kein Deep-Black-Bleed */
        html:not(.dark) .carbon-console,
        html:not(.dark) .carbon-panel {
            border: 1px solid #D6D3D1;
            box-shadow: 0 12px 28px -12px rgba(28, 25, 23, 0.18);
            background-color: var(--pe-bg-card);
        }
        html:not(.dark) .carbon-console::after,
        html:not(.dark) .carbon-panel::after {
            background: none;
        }
        html:not(.dark) .metal-badge {
            background: linear-gradient(to bottom, var(--pe-bg-elevated), var(--pe-bg-tile-header));
            border: 1px solid #D6D3D1;
            box-shadow: inset 0 1px 0 rgba(255,255,255,0.8), 0 2px 6px rgba(28,25,23,0.06);
        }
        html:not(.dark) .carbon-console__body,
        html:not(.dark) .carbon-panel__body,
        html:not(.dark) .carbon-console__head,
        html:not(.dark) .carbon-panel__head {
            background-color: var(--pe-bg-card);
        }

        /* NEON LED COLORS */
        .led-purple  { color: #c084fc; text-shadow: 0 0 10px rgba(192,132,252,0.6), 0 0 20px rgba(192,132,252,0.3); }
        .led-emerald { color: #10b981; text-shadow: 0 0 10px rgba(16,185,129,0.6), 0 0 20px rgba(16,185,129,0.3); }
        .led-lime    { color: #a3e635; text-shadow: 0 0 10px rgba(163,230,53,0.6),  0 0 20px rgba(163,230,53,0.3); }
        .led-amber   { color: #fbbf24; text-shadow: 0 0 10px rgba(251,191,36,0.6),  0 0 20px rgba(251,191,36,0.3); }
        .led-orange  { color: #fb923c; text-shadow: 0 0 10px rgba(251,146,60,0.6),  0 0 20px rgba(251,146,60,0.3); }
        .led-red     { color: #ef4444; text-shadow: 0 0 10px rgba(239,68,68,0.6),   0 0 20px rgba(239,68,68,0.3); }
        .led-gold    { color: #E6C299; text-shadow: 0 0 10px rgba(230,194,153,0.6), 0 0 20px rgba(230,194,153,0.3); }
        .led-white   { color: #fff; text-shadow: 0 0 15px rgba(255,255,255,0.5); }

        .metal-badge {
            background: linear-gradient(to bottom, #222, #0a0a0a);
            border: 1px solid #333;
            box-shadow: inset 0 1px 0 rgba(255,255,255,0.1), 0 4px 10px rgba(0,0,0,0.8);
            border-radius: 6px;
        }

        /* 3D BALKEN */
        .bar-monolith-bedienung { 
            width: 100%; 
            background: linear-gradient(90deg, #1c1c1c 0%, #4a4a4a 40%, #555 60%, #1c1c1c 100%); 
            border-top: 2px solid #aaa; 
            border-radius: 4px 4px 0 0; 
            box-shadow: -8px 0 15px rgba(0,0,0,0.8), inset 0 2px 8px rgba(255,255,255,0.3); 
            transition: height 1s cubic-bezier(0.16, 1, 0.3, 1); 
        }
        .bar-monolith-verkauf { 
            width: 100%; 
            background: linear-gradient(90deg, #785a36 0%, #c49964 40%, #E6C299 60%, #785a36 100%); 
            border-top: 2px solid #fff; 
            border-radius: 4px 4px 0 0; 
            box-shadow: 0 0 25px rgba(230, 194, 153, 0.4), inset 0 2px 8px rgba(255,255,255,0.6); 
            transition: height 1s cubic-bezier(0.16, 1, 0.3, 1) 0.1s; 
        }

        .tacho-tick-micro { stroke: rgba(255,255,255,0.12); stroke-width: 1.5; stroke-linecap: round; }
        .tacho-tick-minor { stroke: rgba(255,255,255,0.28); stroke-width: 2; stroke-linecap: round; }
        .tacho-tick-major { stroke: rgba(255,255,255,0.65); stroke-width: 3; stroke-linecap: round; }
        .tacho-scale-num { fill: #a8a29e; }

        /* Light Mode: Gold-Text, LEDs & helle Tachos */
        html:not(.dark) .text-phantom-gold { color: var(--pe-accent-text); }
        html:not(.dark) .led-purple  { color: #7C3AED; text-shadow: none; }
        html:not(.dark) .led-emerald { color: #047857; text-shadow: none; }
        html:not(.dark) .led-lime    { color: #4D7C0F; text-shadow: none; }
        html:not(.dark) .led-amber   { color: #B45309; text-shadow: none; }
        html:not(.dark) .led-orange  { color: #C2410C; text-shadow: none; }
        html:not(.dark) .led-red     { color: #B91C1C; text-shadow: none; }
        html:not(.dark) .led-gold    { color: var(--pe-accent-text); text-shadow: none; }
        html:not(.dark) .led-white   { color: var(--pe-text-primary); text-shadow: none; }
        html:not(.dark) .tacho-tick-micro { stroke: rgba(28,25,23,0.2); }
        html:not(.dark) .tacho-tick-minor { stroke: rgba(28,25,23,0.4); }
        html:not(.dark) .tacho-tick-major { stroke: rgba(28,25,23,0.75); }
        html:not(.dark) .tacho-scale-num { fill: #1c1917; }
    `}</style>
);

// ============================================================================
// HILFS-FUNKTIONEN
// ============================================================================
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const parseVal = (val: any): number => {
    if (val === null || val === undefined) return 0;
    if (typeof val === 'number') return val;
    if (typeof val === 'string') {
        const clean = val.replace(/\./g, '').replace(',', '.');
        const num = parseFloat(clean);
        return isNaN(num) ? 0 : num;
    }
    return 0;
};

const safeDiv = (numerator: number, denominator: number): number => {
    const num = Number(numerator);
    const den = Number(denominator);
    if (!den || isNaN(num) || isNaN(den)) return 0;
    return num / den;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getSafeVal = (m: any, keyLower: string, keyCamel: string): number => {
    const val = m?.[keyLower] ?? m?.[keyCamel];
    if (val === null || val === undefined || val === '') return 0;
    if (typeof val === 'number') return val;
    return parseFloat(String(val).replace(/\./g, '').replace(',', '.')) || 0;
};

const formatDynamicPercent = (val: number) => {
    const formatted = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(Math.abs(val)) + '%';
    return val > 0 ? '+' + formatted : (val < 0 ? '-' + formatted : '0,0%');
};

const formatVkPercent = (val: number) => {
    return new Intl.NumberFormat('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(val) + '%';
};

const getHealthStatus = (value: number, type: 'effizienz' | 'auslastung' | 'vk' | 'rentabilitaet', gehalt: number = 0, ueberschussProzent: number = 0) => {
    let level = 6;
    let overrideLabel = ''; 
    let overrideText = ''; 
    
    if (type === 'auslastung') {
        if (value >= 0.85) level = 1; else if (value >= 0.75) level = 2; else if (value >= 0.70) level = 3; else if (value >= 0.60) level = 4; else if (value >= 0.50) level = 5;
    } else if (type === 'effizienz') {
        if (value >= 1.00) level = 1; else if (value >= 0.95) level = 2; else if (value >= 0.89) level = 3; else if (value >= 0.72) level = 4; else if (value >= 0.63) level = 5;
    } else if (type === 'vk') {
        if (value >= 0.15) level = 1; else if (value >= 0.10) level = 2; else if (value >= 0.07) level = 3; else if (value >= 0.05) level = 4; else if (value >= 0.03) level = 5;
    } else if (type === 'rentabilitaet') {
        const evalResult = evaluateRentabilitaet(gehalt, ueberschussProzent);
        
        if (evalResult.status === 'Exzellent') level = 1;         
        else if (evalResult.status === 'Gut') level = 2;          
        else if (evalResult.status === 'Solide') level = 3;       
        else if (evalResult.status === 'Grenzwertig') level = 4;  
        else if (evalResult.status === 'Kritisch') level = 5;     
        else level = 6;                                           
        
        overrideLabel = evalResult.status === 'Kritisch' ? 'KRITISCH' : evalResult.status.toUpperCase();
        if (level === 5 || level === 6) overrideLabel = 'KRITISCH BIS INSTABIL';

        switch (evalResult.status) {
            case 'Exzellent': overrideText = "Hervorragende Rentabilität. Das absolute Gehalt und der Überschuss sind zukunftssicher."; break;
            case 'Gut': overrideText = "Gute Rentabilität. Das Gehalt und der Überschuss bilden ein gesundes Fundament."; break;
            case 'Solide': overrideText = "Solide Rentabilität. Das Geschäft trägt sich gut, bietet aber noch Optimierungspotenzial."; break;
            case 'Grenzwertig': overrideText = "Grenzwertige Rentabilität. Der Überschuss oder das Gehalt ist zu niedrig für langfristige Sicherheit."; break;
            case 'Kritisch': 
            default: overrideText = "Veto-Auslösung: Kritischer Zustand. Weder das absolute Gehalt noch der Überschuss sind tragfähig."; break;
        }
    }
    
    // 💉 TS-FIX: Hier sagen wir TypeScript explizit, dass 'text' erlaubt ist
    let config: { label: string; colorClass: string; badgeClass: string; tableBadgeClass: string; text?: string };
    
    switch (level) {
        case 1: config = { 
            label: 'Exzellent', 
            colorClass: 'text-purple-400 led-purple', 
            badgeClass: 'text-purple-400 border-purple-500/50 bg-purple-950/20 shadow-[0_0_8px_rgba(168,85,247,0.4)]',
            tableBadgeClass: 'bg-slate-900 border border-purple-500 text-purple-400 shadow-[0_0_10px_rgba(168,85,247,0.5)]'
        }; break;
        case 2: config = { 
            label: 'Sehr Gut', 
            colorClass: 'text-emerald-400 led-emerald', 
            badgeClass: 'text-emerald-400 border-emerald-500/50 bg-emerald-950/20',
            tableBadgeClass: 'bg-slate-900 border border-emerald-500 text-emerald-400'
        }; break;
        case 3: config = { 
            label: 'Gut', 
            colorClass: 'text-lime-400 led-lime', 
            badgeClass: 'text-lime-400 border-lime-500/50 bg-lime-950/20',
            tableBadgeClass: 'bg-slate-900 border border-lime-500 text-lime-400'
        }; break;
        case 4: config = { 
            label: 'Akzeptabel', 
            colorClass: 'text-yellow-400 led-amber', 
            badgeClass: 'text-yellow-400 border-yellow-500/50 bg-yellow-950/20',
            tableBadgeClass: 'bg-slate-900 border border-yellow-500 text-yellow-400'
        }; break;
        case 5: config = { 
            label: 'Kritisch', 
            colorClass: 'text-orange-400 led-orange', 
            badgeClass: 'text-orange-400 border-orange-500/50 bg-orange-950/20',
            tableBadgeClass: 'bg-slate-900 border border-orange-500 text-orange-400'
        }; break;
        case 6: default: config = { 
            label: 'Defizitär', 
            colorClass: 'text-red-400 led-red', 
            badgeClass: 'text-red-400 border-red-500/50 bg-red-950/20',
            tableBadgeClass: 'bg-slate-900 border border-red-500 text-red-400'
        }; break;
    }

    if (overrideLabel) config.label = overrideLabel;
    if (overrideText) config.text = overrideText;

    return config;
};

const HjIcon = ({ status }: { status: string }) => {
    switch (status) {
        case 'ok': return <ThumbsUp className="w-4 h-4 text-emerald-500 drop-shadow-[0_0_5px_rgba(16,185,129,0.5)]" />;
        case 'warnung': return <AlertTriangle className="w-4 h-4 text-amber-500 drop-shadow-[0_0_5px_rgba(245,158,11,0.5)]" />;
        case 'schlecht': return <ThumbsDown className="w-4 h-4 text-red-500 drop-shadow-[0_0_5px_rgba(239,68,68,0.5)]" />;
        default: return <Ban className="w-4 h-4 text-slate-600" />;
    }
};


// ============================================================================
// KOMPONENTE: CEO FINANZ-MATRIX
// ============================================================================
const CEOFinanzMatrix = ({ 
    nettoKosten, 
    nettoIst, 
    vatMult, 
    ruecklagenZielFaktor, 
    currency = "EUR",
    wochensatz = 4.33,
    oeffnungstage = 5,
    oeffnungsstunden = 40
}: { 
    nettoKosten: number, 
    nettoIst: number, 
    vatMult: number, 
    ruecklagenZielFaktor: number, 
    currency?: string,
    wochensatz?: number,
    oeffnungstage?: number,
    oeffnungsstunden?: number
}) => {
    
    const [timeframe, setTimeframe] = useState<'Stunde' | 'Tag' | 'Woche' | 'Monat'>('Monat');

    const divisor = timeframe === 'Woche' ? wochensatz :
                    timeframe === 'Tag' ? (wochensatz * oeffnungstage) :
                    timeframe === 'Stunde' ? (wochensatz * oeffnungsstunden) : 1;

    const timeNettoKosten = nettoKosten / divisor;
    const timeNettoIst = nettoIst / divisor;
    
    const nettoZiel = timeNettoKosten * (1 + ruecklagenZielFaktor);

    const bruttoKosten = timeNettoKosten * vatMult;
    const bruttoZiel   = nettoZiel * vatMult;
    const bruttoIst    = timeNettoIst * vatMult;

    const sollMargePct = ruecklagenZielFaktor * 100;
    const istMargePct  = timeNettoKosten > 0 ? ((timeNettoIst / timeNettoKosten) - 1) * 100 : 0;
    
    const istRuecklagenEur = timeNettoIst - timeNettoKosten;
    const zielRuecklagenEur = timeNettoKosten * ruecklagenZielFaktor;
    const deltaRuecklagenEur = istRuecklagenEur - zielRuecklagenEur;

    const isProfitabel = istRuecklagenEur >= 0;
    const isUeberZiel = deltaRuecklagenEur >= 0;

    const fmt = (val: number) => new Intl.NumberFormat('de-DE', { maximumFractionDigits: 0 }).format(val);
    const fmtDec = (val: number) => new Intl.NumberFormat('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(val);

    let dynamicBorder = "";
    let dynamicLed = "";
    let dynamicText = "";
    let dynamicBg = "";

    if (isUeberZiel) {
        dynamicBorder = "border-emerald-500/30";
        dynamicLed = "led-emerald";
        dynamicText = "text-emerald-400";
        dynamicBg = "bg-emerald-950/20";
    } else if (isProfitabel) {
        dynamicBorder = "border-amber-500/30";
        dynamicLed = "led-amber";
        dynamicText = "text-amber-400";
        dynamicBg = "bg-amber-950/20";
    } else {
        dynamicBorder = "border-red-500/30";
        dynamicLed = "led-red";
        dynamicText = "text-red-400";
        dynamicBg = "bg-red-950/20";
    }

    const getMarkerPosition = () => {
        const be = timeNettoKosten;
        const ziel = nettoZiel;
        const ist = timeNettoIst;

        if (ist <= be) {
            if (be === 0) return 0;
            return (ist / be) * 33.33;
        } else if (ist <= ziel) {
            const range = ziel - be;
            if (range <= 0) return 33.33;
            return 33.33 + ((ist - be) / range) * 33.33;
        } else {
            const range = ziel * 0.2; 
            if (range <= 0) return 66.66;
            const overflow = Math.min(ist - ziel, range); 
            return 66.66 + ((overflow / range) * 33.33);
        }
    };

    return (
        <div className="carbon-panel carbon-panel--split mb-6">
            <div className="carbon-panel__head carbon-weave-bg carbon-content flex flex-col md:flex-row items-start md:items-center justify-between border-b border-pe-border-strong gap-6">
                <div className="flex items-center gap-4">
                    <div className="metal-badge p-3"><Target className="w-7 h-7 text-phantom-gold" /></div>
                    <div>
                        <h2 className="text-3xl font-black text-pe-text tracking-widest uppercase">CEO Finanz-Matrix</h2>
                        <p className="text-xs text-pe-muted font-bold uppercase tracking-[0.15em] mt-1">Durchschnitt (Brutto) • Ansicht: {timeframe}</p>
                    </div>
                </div>

                <div className="flex items-center p-1 bg-pe-card border border-pe-border rounded-lg shadow-inner">
                    {['Stunde', 'Tag', 'Woche', 'Monat'].map(t => (
                        <button
                            key={t}
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            onClick={() => setTimeframe(t as any)}
                            className={`px-4 py-2 text-[10px] font-bold uppercase tracking-widest rounded-md transition-all ${timeframe === t ? 'bg-gradient-to-b from-[#E6C299] to-[#b48a56] text-black shadow-[0_0_15px_rgba(230,194,153,0.4)]' : 'text-pe-muted hover:text-slate-300'}`}
                        >
                            {t}
                        </button>
                    ))}
                </div>
            </div>

            <div className="carbon-panel__body carbon-content grid grid-cols-1 md:grid-cols-4 gap-8 divide-y md:divide-y-0 md:divide-x divide-slate-800">
                
                {/* 1. Kostendeckung */}
                <div className="flex flex-col items-center text-center px-4">
                    <div className="flex flex-col items-center gap-2 mb-6">
                        <ShieldCheck className="w-5 h-5 text-red-500" />
                        <span className="text-xs font-semibold text-stone-700 dark:text-pe-muted uppercase tracking-wider">Kostendeckung</span>
                    </div>
                    <div className="flex flex-col items-center mb-4">
                        <div className="flex items-baseline justify-center gap-2 mb-1">
                            <span className="text-4xl font-black font-mono-numbers text-stone-900 dark:text-slate-200">{fmt(bruttoKosten)}</span>
                            <span className="text-xs font-bold text-stone-600 dark:text-pe-muted uppercase">{currency}</span>
                        </div>
                        <span className="text-xs text-stone-700 dark:text-pe-muted font-mono-numbers font-bold">Netto: {fmt(timeNettoKosten)} EUR</span>
                    </div>
                    <div className="mt-auto w-full pt-6 border-t border-pe-border-strong text-center">
                        <span className="text-[10px] font-bold text-stone-700 dark:text-slate-400 uppercase tracking-widest">Das Pflicht-Minimum (0% Marge)</span>
                    </div>
                </div>

                {/* 2. Wunsch-Ziel */}
                <div className="flex flex-col items-center text-center px-4 md:px-8">
                    <div className="flex flex-col items-center gap-2 mb-6">
                        <div className="flex items-center justify-center gap-2">
                            <Target className="w-4 h-4 text-phantom-gold" />
                            <span className="text-[11px] font-bold text-phantom-gold uppercase tracking-widest">Wunsch-Ziel</span>
                        </div>
                        <span className="text-[10px] font-bold font-mono-numbers px-2 py-0.5 rounded bg-amber-950/40 text-phantom-gold border border-phantom-gold/30">
                            +{fmtDec(sollMargePct)}%
                        </span>
                    </div>
                    <div className="flex flex-col items-center mb-4">
                        <div className="flex items-baseline justify-center gap-2 mb-1">
                            <span className="text-4xl font-black font-mono-numbers led-gold">{fmt(bruttoZiel)}</span>
                            <span className="text-xs font-bold text-phantom-gold/50 uppercase">{currency}</span>
                        </div>
                        <span className="text-xs text-pe-muted font-mono-numbers font-bold">Netto: {fmt(nettoZiel)} EUR</span>
                    </div>
                    <div className="mt-auto w-full pt-6 border-t border-pe-border-strong text-center">
                        <span className="text-xs font-semibold text-pe-muted uppercase tracking-wider">Inkl. {fmtDec(sollMargePct)}% Soll-Marge</span>
                    </div>
                </div>

                {/* 3. Reales Ist */}
                <div className="flex flex-col items-center text-center px-4 md:px-8">
                    <div className="flex flex-col items-center gap-2 mb-6">
                        <div className="flex items-center justify-center gap-2">
                            <Activity className={`w-4 h-4 ${dynamicText}`} />
                            <span className="text-[11px] font-bold text-pe-text uppercase tracking-widest">Reales Ist</span>
                        </div>
                        <span className={`text-[10px] font-bold font-mono-numbers px-2 py-0.5 rounded border ${isUeberZiel ? 'bg-emerald-100 dark:bg-emerald-950/40 text-emerald-800 dark:text-emerald-400 border-emerald-300 dark:border-emerald-500/30' : (isProfitabel ? 'bg-amber-100 dark:bg-amber-950/40 text-amber-800 dark:text-amber-400 border-amber-300 dark:border-amber-500/30' : 'bg-red-100 dark:bg-red-950/40 text-red-800 dark:text-red-400 border-red-300 dark:border-red-500/30')}`}>
                            {istMargePct > 0 ? '+' : ''}{fmtDec(istMargePct)}%
                        </span>
                    </div>
                    <div className="flex flex-col items-center mb-4">
                        <div className="flex items-baseline justify-center gap-2 mb-1">
                            <span className={`text-4xl font-black font-mono-numbers ${dynamicLed}`}>{fmt(bruttoIst)}</span>
                            <span className="text-xs font-bold text-pe-muted uppercase">{currency}</span>
                        </div>
                        <span className="text-xs text-pe-muted font-mono-numbers font-bold">Netto: {fmt(timeNettoIst)} EUR</span>
                    </div>
                    <div className="mt-auto w-full pt-6 border-t border-pe-border-strong text-center">
                        <span className={`text-[10px] font-bold uppercase tracking-widest flex items-center justify-center gap-2 ${dynamicText}`}>
                            <div className={`w-1.5 h-1.5 rounded-full animate-pulse ${isUeberZiel ? 'bg-emerald-500' : (isProfitabel ? 'bg-amber-500' : 'bg-red-500')}`}></div> 
                            {isUeberZiel ? 'Performance Exzellent' : (isProfitabel ? 'Kostendeckend (Ziel offen)' : 'Leistungshinweis: Verlust')}
                        </span>
                    </div>
                </div>

                {/* 4. GEBILDETE RÜCKLAGEN */}
                <div className="flex flex-col items-center text-center px-4 md:px-6 min-w-0 h-full w-full">
                    <div className={`metal-badge dark:bg-black/60 w-full max-w-[15.5rem] mx-auto p-5 flex flex-col justify-between shadow-inner border ${dynamicBorder} h-full min-h-[220px] overflow-hidden`}>
                        <div className="flex items-center justify-center gap-2 mb-4">
                            <span className="text-xs font-semibold text-pe-muted uppercase tracking-wider leading-tight">Gebildete Rücklagen ({timeframe})</span>
                            <Info className="w-3 h-3 text-pe-muted shrink-0" />
                        </div>
                        
                        <div className="flex flex-col items-center gap-1 mb-4 w-full">
                            <div className="flex items-baseline justify-center gap-1.5 flex-wrap">
                                <span className={`text-3xl font-black font-mono-numbers ${dynamicLed}`}>
                                    {istRuecklagenEur > 0 ? '+' : ''}{fmt(istRuecklagenEur)}
                                </span>
                                <span className="text-sm font-bold text-slate-300 uppercase">{currency}</span>
                            </div>
                            <span className={`text-xs font-bold ${dynamicText}`}>({fmtDec(istMargePct)}%)</span>
                        </div>

                        <div className="mt-auto w-full pt-4 border-t border-slate-800">
                            <div className="flex justify-between items-center gap-2 mb-2">
                                <span className="text-[10px] text-pe-muted font-bold uppercase">Ziel ({fmtDec(sollMargePct)}%):</span>
                                <span className="text-xs font-mono font-bold text-pe-muted whitespace-nowrap">{fmt(zielRuecklagenEur)} {currency}</span>
                            </div>
                            <div className="flex justify-between items-center gap-2">
                                <span className="text-[10px] text-pe-muted font-bold uppercase">Differenz:</span>
                                <span className={`text-xs font-mono font-black whitespace-nowrap ${isUeberZiel ? 'text-emerald-400' : 'text-red-400'}`}>
                                    {deltaRuecklagenEur > 0 ? '+' : ''}{fmt(deltaRuecklagenEur)} {currency}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            {/* 5. RENTABILITÄTS-SKALA (DIREKT UNTER DER MATRIX) */}
            <div className="carbon-content mt-10 pt-8 border-t border-pe-border-strong">
                <div className="flex justify-between items-end mb-5">
                    <h4 className="text-xs font-semibold text-pe-muted uppercase tracking-wider">Rentabilitäts-Skala (Netto)</h4>
                    <div className="text-right flex flex-col items-end">
                        <span className="text-xs font-semibold text-pe-muted uppercase tracking-wider mb-2">Erreichter Ø Umsatz ({timeframe})</span>
                        <div className={`border ${dynamicBorder} ${dynamicBg} px-5 py-2 rounded-xl shadow-inner inline-flex flex-col items-center justify-center`}>
                            <div className="flex items-baseline gap-1.5 mb-0.5">
                                <span className={`text-2xl font-black font-mono-numbers ${dynamicLed}`}>{fmt(bruttoIst)}</span>
                                <span className="text-xs font-bold text-pe-muted uppercase">{currency}</span>
                            </div>
                            <span className="text-[10px] font-mono-numbers font-bold text-pe-muted">Netto: {fmt(timeNettoIst)} {currency}</span>
                        </div>
                    </div>
                </div>
                
                <div className="relative h-10 bg-pe-sunken dark:bg-black rounded-lg overflow-hidden flex border border-pe-border dark:border-[#222] shadow-inner">
                    <div className="h-full w-1/3 bg-red-100 dark:bg-red-950/40 border-r border-pe-border-strong flex items-center px-4">
                        <span className="text-[10px] uppercase tracking-widest font-bold text-red-700 dark:text-red-500 truncate">Unter Deckung</span>
                    </div>
                    <div className="h-full w-1/3 bg-amber-100 dark:bg-amber-950/40 border-r border-pe-border-strong flex items-center px-4">
                        <span className="text-[10px] uppercase tracking-widest font-bold text-amber-700 dark:text-amber-500 truncate">Zone Deckung</span>
                    </div>
                    <div className="h-full w-1/3 bg-emerald-100 dark:bg-emerald-950/40 flex items-center px-4">
                        <span className="text-[10px] uppercase tracking-widest font-bold text-emerald-700 dark:text-emerald-400 truncate">Zielbereich Profitabel</span>
                    </div>
                    
                    <div 
                        className="absolute top-0 bottom-0 w-2 bg-white border-2 border-orange-500 shadow-[0_0_10px_rgba(249,115,22,0.8)] z-10 transition-all duration-500"
                        style={{ left: `calc(${getMarkerPosition()}% - 4px)` }}
                    />
                </div>
            </div>
        </div>
    );
};

// ============================================================================
// KOMPONENTE: TACHO & BAROMETER
// ============================================================================
const CarbonSpeedometer = ({ label, actual, recommended, maxScale, currency, sollMargin, istMargin }: { label: string, actual: number, recommended: number, maxScale: number, currency: string, sollMargin?: number, istMargin?: number }) => {
    const startAngle = 140; const sweepAngle = 260; 
    const valToAngle = (val: number) => startAngle + (Math.min(Math.max(val, 0), maxScale) / maxScale) * sweepAngle;

    const ticks = [];
    for (let i = 0; i <= maxScale; i += 5) {
        ticks.push({ value: i, angle: valToAngle(i), isMajor: i % 20 === 0, isMinor: i % 10 === 0 && i % 20 !== 0 });
    }

    const actualAngle = valToAngle(actual);
    const recAngle = valToAngle(recommended);
    const delta = actual - recommended;
    const isUnderperforming = delta < 0;

    return (
        <div className="flex flex-col items-center w-full max-w-[300px] carbon-content mx-auto">
            <div className="h-16 flex flex-col justify-end mb-4 text-center">
                <span className="text-[10px] text-stone-700 dark:text-slate-300 font-bold uppercase tracking-widest text-center leading-tight">{label}</span>
                <span className="text-[10px] text-transparent mt-1">.</span>
            </div>
            
            <div className="relative w-60 h-60 flex items-center justify-center">
                {/* Dark: dunkles Zifferblatt · Light: hell & lesbar */}
                <div className="absolute inset-0 z-0 rounded-full border-2 border-stone-300 bg-gradient-to-b from-[#F7F4EF] via-[#F0EBE3] to-[#E8E2D8] shadow-[inset_0_2px_8px_rgba(255,255,255,0.85),0_12px_28px_rgba(0,0,0,0.12)] dark:border-[#111] dark:bg-gradient-to-b dark:from-[#1a1a1a] dark:via-[#0a0a0a] dark:to-[#000] dark:shadow-[inset_0_15px_25px_rgba(0,0,0,0.9),0_15px_30px_rgba(0,0,0,0.9)]"></div>
                <svg viewBox="0 0 200 200" className="w-full h-full overflow-visible z-10 dark:drop-shadow-2xl">
                    <defs>
                        <filter id="glow-red"><feGaussianBlur stdDeviation="3" result="coloredBlur"/><feMerge><feMergeNode in="coloredBlur"/><feMergeNode in="SourceGraphic"/></feMerge></filter>
                        <filter id="glow-green"><feGaussianBlur stdDeviation="3" result="coloredBlur"/><feMerge><feMergeNode in="coloredBlur"/><feMergeNode in="SourceGraphic"/></feMerge></filter>
                        <filter id="glow-gold"><feGaussianBlur stdDeviation="2" result="coloredBlur"/><feMerge><feMergeNode in="coloredBlur"/><feMergeNode in="SourceGraphic"/></feMerge></filter>
                        <linearGradient id="needleActualRed" x1="0" y1="0" x2="1" y2="1"><stop offset="0%" stopColor="#ef4444"/><stop offset="100%" stopColor="#7f1d1d"/></linearGradient>
                        <linearGradient id="needleActualGreen" x1="0" y1="0" x2="1" y2="1"><stop offset="0%" stopColor="#10b981"/><stop offset="100%" stopColor="#064e3b"/></linearGradient>
                    </defs>
                    <path d={`M ${100 + 85 * Math.cos(startAngle * Math.PI / 180)} ${100 + 85 * Math.sin(startAngle * Math.PI / 180)} A 85 85 0 1 1 ${100 + 85 * Math.cos((startAngle + sweepAngle) * Math.PI / 180)} ${100 + 85 * Math.sin((startAngle + sweepAngle) * Math.PI / 180)}`} fill="none" stroke="currentColor" className="text-stone-300 dark:text-[#111]" strokeWidth="10" strokeLinecap="round" />
                    <g>{ticks.map((tick) => (
                        <g key={tick.value} transform={`translate(100, 100) rotate(${tick.angle})`}>
                            <line x1={tick.isMajor ? "73" : (tick.isMinor ? "77" : "80")} y1="0" x2="85" y2="0" className={tick.isMajor ? "tacho-tick-major" : (tick.isMinor ? "tacho-tick-minor" : "tacho-tick-micro")} />
                            {tick.isMajor && (
                                <text
                                    x="58"
                                    y="0"
                                    fontSize="11"
                                    fontWeight="800"
                                    textAnchor="middle"
                                    alignmentBaseline="middle"
                                    transform={`rotate(${-tick.angle}, 58, 0)`}
                                    className="font-mono-numbers tacho-scale-num"
                                >
                                    {tick.value}
                                </text>
                            )}
                        </g>
                    ))}</g>
                    <g transform={`translate(100, 100) rotate(${recAngle})`} filter="url(#glow-gold)" opacity="0.95">
                        <polygon points="70,-4 90,0 70,4" fill="#B45309" className="dark:hidden" />
                        <polygon points="70,-4 90,0 70,4" fill="#E6C299" className="hidden dark:block" />
                    </g>
                    <g transform={`translate(100, 100) rotate(${actualAngle})`} filter={isUnderperforming ? "url(#glow-red)" : "url(#glow-green)"} className="transition-transform duration-500 ease-out">
                        <polygon points="-12,-3 88,0 -12,3" fill={isUnderperforming ? "url(#needleActualRed)" : "url(#needleActualGreen)"} />
                        <circle cx="0" cy="0" r="8" className="fill-stone-100 dark:fill-[#111]" stroke={isUnderperforming ? "#ef4444" : "#10b981"} strokeWidth="2" />
                        <circle cx="0" cy="0" r="3" className="fill-stone-900 dark:fill-white" />
                    </g>
                </svg>
                <div className="absolute top-[62%] flex flex-col items-center justify-center z-20 w-full px-4">
                    <div className="rounded-lg border border-pe-border-strong bg-pe-card px-4 py-1.5 flex items-baseline justify-center gap-1 shadow-md dark:border-pe-border-strong dark:bg-black/80 dark:shadow-inner metal-badge">
                        <span className="text-3xl font-black font-mono-numbers text-stone-900 dark:text-white dark:led-white">{actual}</span>
                        <span className="text-[10px] font-bold text-stone-500 dark:text-pe-muted ml-0.5">{currency}</span>
                    </div>
                </div>
            </div>
            
            {/* --- NEUES HARMONISCHES LAYOUT --- */}
            <div className="w-full mt-6 flex flex-col gap-2 px-2">
                <div className="relative flex justify-between w-full gap-3">
                    <div className="flex-1 flex flex-col items-center text-center metal-badge px-2 py-2 bg-pe-card">
                        <span className="text-[10px] font-bold uppercase tracking-widest mb-1 text-pe-muted">Soll</span>
                        <div className="flex items-baseline gap-0.5">
                            <span className="text-xl font-black font-mono-numbers text-phantom-gold led-gold">{recommended}</span>
                            <span className="text-[9px] font-bold text-phantom-gold/60 uppercase">{currency}</span>
                        </div>
                    </div>
                    
                    <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 bg-pe-card dark:bg-[#0a0a0a] border border-pe-border-strong rounded-full p-2 shadow-[0_0_10px_rgba(0,0,0,1)] z-10 pointer-events-none">
                        <TrendingUp className="w-4 h-4 text-pe-muted" />
                    </div>

                    <div className={`flex-1 flex flex-col items-center text-center metal-badge px-2 py-2 bg-pe-card border ${isUnderperforming ? 'border-red-500/30' : 'border-emerald-500/30'}`}>
                        <span className={`text-[10px] font-bold uppercase tracking-widest mb-1 ${isUnderperforming ? 'text-red-400' : 'text-emerald-400'}`}>Ist</span>
                        <div className="flex items-baseline gap-0.5">
                            <span className={`text-xl font-black font-mono-numbers ${isUnderperforming ? 'text-red-400 led-red' : 'text-emerald-400 led-emerald'}`}>{actual}</span>
                            <span className={`text-[9px] font-bold uppercase ${isUnderperforming ? 'text-red-500/70' : 'text-emerald-500/70'}`}>{currency}</span>
                        </div>
                    </div>
                </div>

                {(sollMargin !== undefined || istMargin !== undefined) && (
                    <div className="flex justify-between items-center w-full gap-3 mt-1">
                        <div className="flex-1">
                            {sollMargin !== undefined && (
                                <div className="bg-pe-card dark:bg-[#0a0a0a] border border-pe-border-strong dark:border-[#222] py-1.5 rounded-md shadow-inner w-full flex justify-center items-center">
                                    <span className="text-[10px] lg:text-[11px] font-mono-numbers font-bold text-amber-900 dark:text-phantom-gold tracking-wider uppercase whitespace-nowrap">
                                        Rendite: {sollMargin.toFixed(1)}%
                                    </span>
                                </div>
                            )}
                        </div>
                        <div className="flex-1">
                            {istMargin !== undefined && sollMargin !== undefined && (
                                <div className={`bg-pe-card dark:bg-[#0a0a0a] border py-1.5 rounded-md shadow-inner w-full flex justify-center items-center ${istMargin >= sollMargin ? 'border-emerald-600/40 dark:border-emerald-500/20' : 'border-red-600/40 dark:border-red-500/20'}`}>
                                    <span className={`text-[10px] lg:text-[11px] font-mono-numbers font-bold tracking-wider uppercase whitespace-nowrap ${istMargin >= sollMargin ? 'text-emerald-800 dark:text-emerald-400' : 'text-red-800 dark:text-red-400'}`}>
                                        Rendite: {istMargin.toFixed(1)}% <span className="opacity-80 ml-0.5">(Δ {(istMargin - sollMargin) > 0 ? '+' : ''}{(istMargin - sollMargin).toFixed(1)}%)</span>
                                    </span>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const BarometerTool = ({ title, icon: Icon, actualBase, recommendedBase, isMaterial = false, currency = "EUR" }: { title: string, icon: any, actualBase: number, recommendedBase: number, isMaterial?: boolean, currency?: string }) => {
    const times = [10, 15, 20, 30, 40, 45, 50, 60];
    const [activeTime, setActiveTime] = useState<number>(30);
    const [view, setView] = useState<'ist' | 'soll'>('ist');
    const currentBase = view === 'ist' ? actualBase : recommendedBase;
    const activeValue = Math.round(activeTime * (currentBase / 60));
    const R = 45; 
    const baseColorClass = isMaterial ? 'text-emerald-400 led-emerald' : 'text-phantom-gold led-gold';
    const activeIconColor = isMaterial ? 'text-emerald-500/80' : 'text-phantom-gold/80';

    return (
        <div className="flex flex-col items-center w-full max-w-[300px] carbon-content mx-auto">
            <div className="h-16 flex flex-col justify-end mb-4 text-center">
                <span className="text-[10px] text-slate-300 font-bold uppercase tracking-widest text-center leading-tight drop-shadow-md">{title}</span>
                <span className={`text-xl font-black font-mono-numbers mt-1 text-center transition-colors duration-300 flex justify-center items-baseline gap-1 ${baseColorClass}`}>BASIS: {currentBase} <span className="text-[10px] uppercase font-bold tracking-widest text-pe-muted">{currency}</span></span>
            </div>
            <div className="relative w-60 h-60 flex items-center justify-center">
                <div className="absolute inset-0 rounded-full bg-pe-card dark:bg-[#0a0a0a] shadow-[inset_0_10px_20px_rgba(28,25,23,0.15)] dark:shadow-[inset_0_15px_30px_rgba(0,0,0,1),0_15px_30px_rgba(0,0,0,0.8)] border border-pe-border dark:border-[#222]"></div>
                <div className="absolute z-10 flex flex-col items-center justify-center metal-badge w-36 h-36 rounded-full border border-phantom-gold/20 shadow-[0_0_20px_rgba(0,0,0,0.5)] bg-gradient-to-b from-[#1a1a1a] to-[#050505]">
                    <Icon className={`w-4 h-4 mb-1 ${activeIconColor}`} />
                    <span className="text-4xl font-black font-mono-numbers led-white leading-none">{activeTime}</span>
                    <span className="text-[8px] text-pe-muted font-bold uppercase tracking-widest mt-1 mb-1">Minuten</span>
                    <div className="h-px w-20 bg-[#333] my-1"></div>
                    <div className="flex items-baseline justify-center gap-1 mt-1"><span className={`text-2xl font-black font-mono-numbers ${isMaterial ? 'led-emerald' : 'led-gold'}`}>{activeValue}</span><span className="text-[9px] text-pe-muted uppercase font-bold tracking-widest">{currency}</span></div>
                </div>
                <svg viewBox="0 0 100 100" className="absolute inset-0 w-full h-full overflow-visible z-20">
                    <circle cx="50" cy="50" r={R} fill="none" stroke="rgba(255,255,255,0.03)" strokeWidth="1" />
                    {times.map((t, index) => {
                        const angle = (index / times.length) * 2 * Math.PI - (Math.PI / 2);
                        const x = 50 + R * Math.cos(angle); const y = 50 + R * Math.sin(angle);
                        const isActive = t === activeTime;
                        return (
                            <g key={t} className="cursor-pointer" onMouseEnter={() => setActiveTime(t)} onClick={() => setActiveTime(t)}>
                                <circle cx={x} cy={y} r={isActive ? 7 : 4} fill={isActive ? (isMaterial ? '#10b981' : '#E6C299') : '#111'} stroke={isActive ? '#fff' : '#444'} strokeWidth={isActive ? "2" : "1"} className="transition-all duration-300 shadow-lg" />
                                <text x={x} y={y > 50 ? y + 12 : y - 8} textAnchor="middle" alignmentBaseline="middle" fontSize="4.5" fontWeight="900" fill={isActive ? (isMaterial ? '#10b981' : '#E6C299') : '#666'} className="font-mono-numbers pointer-events-none transition-all duration-300">{t}m</text>
                            </g>
                        );
                    })}
                </svg>
            </div>
            <div className="relative flex justify-between w-full mt-6 gap-3 px-2">
                <button onClick={() => setView('soll')} className={`flex-1 flex flex-col items-center text-center metal-badge px-2 py-2 transition-all duration-300 ${view === 'soll' ? 'border-phantom-gold/60 shadow-[0_0_15px_rgba(230,194,153,0.3)] bg-pe-card' : 'border-pe-border-strong opacity-60 hover:opacity-100 bg-pe-card'}`}>
                    <span className={`text-[9px] font-bold uppercase tracking-widest mb-1 ${view === 'soll' ? 'text-phantom-gold' : 'text-pe-muted'}`}>Soll</span>
                    <div className="flex items-baseline gap-0.5">
                        <span className={`text-xl font-black font-mono-numbers ${view === 'soll' ? 'text-pe-text' : 'text-pe-muted'}`}>{recommendedBase}</span>
                        <span className={`text-[9px] font-bold uppercase tracking-widest ${view === 'soll' ? 'text-pe-muted' : 'text-slate-600'}`}>{currency}</span>
                    </div>
                </button>
                <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 bg-pe-card dark:bg-[#0a0a0a] border border-pe-border-strong rounded-full p-2 shadow-[0_0_10px_rgba(0,0,0,1)] z-10 pointer-events-none"><ArrowLeftRight className="w-4 h-4 text-pe-muted" /></div>
                <button onClick={() => setView('ist')} className={`flex-1 flex flex-col items-center text-center metal-badge px-2 py-2 transition-all duration-300 ${view === 'ist' ? (isMaterial ? 'border-emerald-500/60 bg-pe-card' : 'border-red-500/60 bg-pe-card') : 'border-pe-border-strong opacity-60 hover:opacity-100 bg-pe-card'}`}>
                    <span className={`text-[9px] font-bold uppercase tracking-widest mb-1 ${view === 'ist' ? (isMaterial ? 'text-emerald-400' : 'text-red-400') : 'text-pe-muted'}`}>Ist</span>
                    <div className="flex items-baseline gap-0.5">
                        <span className={`text-xl font-black font-mono-numbers ${view === 'ist' ? (isMaterial ? 'led-emerald' : 'led-red') : 'text-pe-muted'}`}>{actualBase}</span>
                        <span className={`text-[9px] font-bold uppercase tracking-widest ${view === 'ist' ? (isMaterial ? 'text-emerald-500/70' : 'text-red-500/70') : 'text-slate-600'}`}>{currency}</span>
                    </div>
                </button>
            </div>
        </div>
    );
};

// ============================================================================
// MAIN COCKPIT
// ============================================================================
export default function HolyGrailDashboard() {
    const calc = useCalculationsSelector();
    const fmt = (val: number) => new Intl.NumberFormat('de-DE').format(Math.round(val));
    const [isAiModalOpen, setIsAiModalOpen] = useState(false);
    const { isTeamMode, bonusById, selectedMemberIds } = useTeamBonus();

    // 💉 CHIRURGIE: COCKPIT STEALTH (GLOBAL VARIABLES)
    const gehalt = calc.gesamtlohn || 0; // 💉 CHIRURGIE: 3.800€ exakt abgegriffen
    const ueberschussProzent = calc.ueberschussProzent || 0; // 💉 CHIRURGIE: 4,7% exakt abgegriffen
    
    const cData = calc.clientData || {};
    const isSolo = cData.isSoloBusiness === true || cData.insiderSoloChecked === true;
    const isBase = cData.basicChecked === true || cData.lizenzDetails?.typ === 'basic' || cData.lizenzDetails?.typ === 'base';
    const showTeamData = !isSolo && !isBase;

    const currency = calc.currencyCode || "EUR";
    const vatMult = 1 + ((calc.mwstSatz || 0) / 100);

    // ========================================================================
    // DATA-BINDING SCHRITT 1: PRICING & TAKTUNGS-MATRIX
    // ========================================================================
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const kalkState = calc.clientData?.kalkulator || {} as any;
    // Nur Mandanten-Akte — keine globalen Settings-Demos
    const adminParamData = Array.isArray(kalkState.priceParameterListe) ? kalkState.priceParameterListe : [];

    const stundenfaktor = Number(kalkState.barometerStundenfaktor ?? 0);
    const echterStundensatz = kalkState.echterStundensatz || 0;
    const useEchterStundensatz = kalkState.useEchterStundensatz || false;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const baseMatParam = adminParamData.length > 0 
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ? (adminParamData.find((p:any) => p.desc.toLowerCase().includes('stundensatz') || p.desc.toLowerCase().includes('verrechnungssatz')) 
           // eslint-disable-next-line @typescript-eslint/no-explicit-any
           || adminParamData.reduce((max:any, p:any) => p.preis > max.preis ? p : max, adminParamData[0]))
        : null;
    
    const targetMatPreis = baseMatParam ? baseMatParam.preis : 0;
    const echterStundensatzMat = kalkState.echterStundensatzMat || 0;
    const useEchterStundensatzMat = kalkState.useEchterStundensatzMat || false;

    const tacho1Recommended = Math.round(stundenfaktor);
    const tacho1Actual = Math.round(useEchterStundensatz && echterStundensatz > 0 ? echterStundensatz : stundenfaktor);

    const tacho2Recommended = Math.round(targetMatPreis);
    const tacho2Actual = Math.round(useEchterStundensatzMat && echterStundensatzMat > 0 ? echterStundensatzMat : targetMatPreis);

    const wochensatz = calc.settings?.global?.Wochensatz || 4.33;
    const oeffnungstage = parseVal(calc.settings?.global?.Oeffnungstage) || 5;
    const oeffnungsstunden = parseVal(calc.settings?.global?.Oeffnungsstunden) || 40;

    // ========================================================================
    // BERECHNUNGS-BLOCK FÜR RÜCKLAGEN-DELTA (KORRIGIERT FÜR TACHOS)
    // ========================================================================
    const basisRuecklage = Number(kalkState.barometerRuecklage ?? 0);
    const targetMatRuecklage = baseMatParam ? baseMatParam.ruecklage : 0;

    const costPerHour1 = tacho1Recommended * (1 - (basisRuecklage / 100));
    const realProfit1 = tacho1Actual - costPerHour1;
    const istMargin1 = tacho1Actual > 0 ? (realProfit1 / tacho1Actual) * 100 : 0;

    const costPerHour2 = tacho2Recommended * (1 - (targetMatRuecklage / 100));
    const realProfit2 = tacho2Actual - costPerHour2;
    const istMargin2 = tacho2Actual > 0 ? (realProfit2 / tacho2Actual) * 100 : 0;

    // ========================================================================
    // DATA-BINDING SCHRITT 2: EXAKTE GLOBALE MODAL-BERECHNUNG
    // ========================================================================
    const gesamtleistungData = calc.clientData?.gesamtleistungData || [];
    const m1 = parseVal(calc.lohnfaktorData?.mindestumsatz1) || calc.sollumsatz || 0;
    const m2 = parseVal(calc.lohnfaktorData?.mindestumsatz2) || calc.sollumsatz || 0;
    const ruecklagenZielFaktor = (parseVal(calc.settings?.global?.Liquiditaet) || 10) / 100;
    const auslastungsVorgabe = calc.auslastungsfaktor || 75;

    let totalBedienBrutto = 0; let totalVkBrutto = 0; let totalGesamtBrutto = 0;
    let totalSollNetto = 0; let activeCount = 0;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    gesamtleistungData.forEach((monat: any, i: number) => {
        const bedien = parseVal(monat.bedienumsatzBrutto ?? monat.bedienUmsatz);
        const vk = parseVal(monat.vkUmsatzBrutto ?? monat.vkUmsatz);
        const gesamt = bedien + vk;
        
        const isLocked = monat.abgeschlossen === true;
        const snap = monat.frozenCalculations || {};

        const currentBaseMindestumsatz = i < 6 ? m1 : m2;
        const activeMindestumsatzBase = (isLocked && snap.mindestumsatzBase !== undefined) ? parseVal(snap.mindestumsatzBase) : currentBaseMindestumsatz;

        const anpassung = monat.kostenErhoeht ? -1 : 1;
        const sollNetto = activeMindestumsatzBase + (parseVal(monat.aussergewoehnlich) * anpassung);

        if (gesamt > 0 || monat.abgeschlossen || monat.festmachen || monat.isLocked) {
            totalBedienBrutto += bedien;
            totalVkBrutto += vk;
            totalGesamtBrutto += gesamt;
            totalSollNetto += sollNetto;
            activeCount++;
        }
    });

    const count = activeCount || 1;
    const avgGesamtBrutto = totalGesamtBrutto / count;
    const avgSollNetto = totalSollNetto / count;
    const avgGesamtNetto = avgGesamtBrutto / vatMult;
    const nettoZiel = avgSollNetto * (1 + ruecklagenZielFaktor);

    const globalVkFaktor = totalBedienBrutto > 0 ? (totalVkBrutto / totalBedienBrutto) : 0;
    const realeRentabilitaet = calc.rentabilitaetIst || 0;

    const monatsStunden = wochensatz * oeffnungsstunden;
    const korrekterSollStundenUmsatzBrutto = safeDiv(m2 * (1 + ruecklagenZielFaktor), monatsStunden) * vatMult;
    const avgStdUmsatzIst = safeDiv(avgGesamtBrutto, monatsStunden);
    const globalAuslastungDecimal = korrekterSollStundenUmsatzBrutto > 0 ? (auslastungsVorgabe / 100) * safeDiv(avgStdUmsatzIst, korrekterSollStundenUmsatzBrutto) : 0;

    // ========================================================================
    // BERECHNUNG: TEAM-EFFIZIENZ (INKL. URLAUBSAUSGLEICH)
    // ========================================================================
    const mitarbeiterLeistung = calc.clientData?.mitarbeiterLeistung || {};
    const geraeteListe = Array.isArray(calc.geraeteListe) ? calc.geraeteListe : [];
    const lohnfaktorAktiv = calc.lohnfaktorAktiv || 0;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const leistungsprovision = (calc.clientData as any)?.leistungsprovision || {};
    const faktorenHJ1 = { 
        bedienung: (leistungsprovision.erstesHalbjahr?.provisionDienstleistung ?? 10) / 100, 
        vk: (leistungsprovision.erstesHalbjahr?.provisionVerkauf ?? 10) / 100 
    };
    const faktorenHJ2 = { 
        bedienung: (leistungsprovision.zweitesHalbjahr?.provisionDienstleistung ?? 10) / 100, 
        vk: (leistungsprovision.zweitesHalbjahr?.provisionVerkauf ?? 10) / 100 
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const realEmployees: any[] = [];

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (calc.personalData || []).forEach((maData: any) => {
        if (['Azubi', 'Prod. Azubi', 'produktiver Azubi'].includes(maData.taetigkeit)) return;
        const raw = mitarbeiterLeistung[maData.id];
        if (!raw) return;

        const wochenstunden = maData.wochenstunden || 0;
        const arbeitstage = maData.arbeitstage || 5;
        if (wochenstunden === 0 || arbeitstage === 0) return;

        const maMonatsStunden = wochenstunden * wochensatz;
        const tagesArbeitszeit = wochenstunden / arbeitstage;
        const effektiverBruttolohn = (maData.grundgehalt || 0) + (maData.lohnkostenzusatz || maData.lohnzusatz || 0);

        let currentLohnfaktor = lohnfaktorAktiv;
        const safeDeviceIds = Array.isArray(raw.selectedDeviceIds) ? raw.selectedDeviceIds : [];

        if (maData.arbeitetMitGeraeten && safeDeviceIds.length > 0) {
            let totalGeraeteProzent = 0;
            safeDeviceIds.forEach((devId: string) => {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const geraet = geraeteListe.find((g: any) => g && g.id === devId);
                if (geraet) {
                    totalGeraeteProzent += (geraet.kostenProzent || 0);
                }
            });
            const faktorZuschlag = (totalGeraeteProzent / 100) * 10;
            currentLohnfaktor += faktorZuschlag;
        }

        const kostendeckungsfaktor = parseVal(calc.lohnfaktorData?.kostendeckungsfaktor1) || 2.8;
        const kostendeckungsumsatz = effektiverBruttolohn * kostendeckungsfaktor;

        const sollUmsatzMonat = effektiverBruttolohn * currentLohnfaktor;
        const sollUmsatzProStunde = safeDiv(sollUmsatzMonat, maMonatsStunden);

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const processHjForMetrics = (hjData: any[] | undefined, bonusFaktoren: any) => {
            if (!Array.isArray(hjData)) return { effSum: 0, count: 0, deltaNettoSum: 0, bonusSum: 0, krank: 0, urlaub: 0, auslastungSum: 0, vkSum: 0, bedienSum: 0, gesamtUmsatzBruttoSum: 0, angepassterSollUmsatzSum: 0, status: 'none' };
            
            let effSum = 0, count = 0, deltaNettoSum = 0, bonusSum = 0;
            let summeIstUmsatz = 0, anzahlMonateMitUmsatz = 0;
            let krank = 0, urlaub = 0, auslastungSum = 0, vkSum = 0, bedienSum = 0;
            let gesamtUmsatzBruttoSum = 0;
            let angepassterSollUmsatzSum = 0;
            
            hjData.forEach(m => {
                const bedien = Number(m?.bedienUmsatz) || 0;
                const vk = Number(m?.vkUmsatz) || 0;
                if ((bedien + vk) > 0) {
                    summeIstUmsatz += (bedien + vk);
                    anzahlMonateMitUmsatz++;
                }
            });
            
            const avgIstUmsatzMonat = anzahlMonateMitUmsatz > 0 ? summeIstUmsatz / anzahlMonateMitUmsatz : 0;
            const avgIstUmsatzProStunde = safeDiv(avgIstUmsatzMonat, maMonatsStunden);

            hjData.forEach(m => {
                const bedien = Number(m?.bedienUmsatz) || 0;
                const vk = Number(m?.vkUmsatz) || 0;
                const gesamtIst = bedien + vk;
                
                if (gesamtIst > 0 || m?.festmachen) {
                    krank += Number(m?.krankheitsTage) || 0;
                    urlaub += Number(m?.urlaubsTage) || 0;
                }

                if (gesamtIst > 0) {
                    count++;
                    bedienSum += bedien;
                    vkSum += vk;

                    const uTage = Number(m?.urlaubsTage) || 0;
                    const urlaubsAusgleich = avgIstUmsatzProStunde * uTage * tagesArbeitszeit;
                    const gesamtUmsatzBrutto = gesamtIst + urlaubsAusgleich;

                    let angepassterSollUmsatz = sollUmsatzMonat;
                    if (!m?.ueberstundenAuszahlen) {
                        angepassterSollUmsatz -= ((Number(m?.unproduktiveStunden) || 0) * sollUmsatzProStunde);
                    }

                    gesamtUmsatzBruttoSum += gesamtUmsatzBrutto;
                    angepassterSollUmsatzSum += angepassterSollUmsatz;
                    
                    const currentEff = safeDiv(gesamtUmsatzBrutto, angepassterSollUmsatz);
                    effSum += currentEff;
                    
                    const umsatzProStunde = safeDiv(gesamtUmsatzBrutto, maMonatsStunden);
                    auslastungSum += (auslastungsVorgabe / 100) * safeDiv(umsatzProStunde, sollUmsatzProStunde) * 100;

                    const deltaBrutto = gesamtUmsatzBrutto - angepassterSollUmsatz;
                    const deltaNetto = deltaBrutto / vatMult;
                    deltaNettoSum += deltaNetto;

                    const vkUmsatzNetto = vk / vatMult;
                    const bonusBedienung = deltaNetto * bonusFaktoren.bedienung;
                    const bonusVK = deltaBrutto > 0 ? vkUmsatzNetto * bonusFaktoren.vk : 0;
                    
                    let finalBonus = bonusBedienung + bonusVK;
                    let b = Number(m?.bonus);
                    if (isNaN(b)) b = Number(m?.provision);
                    if (isNaN(b)) b = Number(m?.erarbeiteterBonus);
                    if (!isNaN(b) && b > 0) finalBonus = b;

                    bonusSum += finalBonus;
                }
            });

            let status = 'none';
            if (count > 0) {
                const avgEff = effSum / count;
                if (avgEff >= 1.0) status = 'ok';
                else if (avgEff >= 0.8) status = 'warnung';
                else status = 'schlecht';
            }

            return { effSum, count, deltaNettoSum, bonusSum, krank, urlaub, auslastungSum, vkSum, bedienSum, status, gesamtUmsatzBruttoSum, angepassterSollUmsatzSum };
        };

        const hj1Metrics = processHjForMetrics(raw.halbjahr1, faktorenHJ1);
        const hj2Metrics = calc.clientData?.isHJ2Freigegeben ? processHjForMetrics(raw.halbjahr2, faktorenHJ2) : { effSum: 0, count: 0, deltaNettoSum: 0, bonusSum: 0, krank: 0, urlaub: 0, auslastungSum: 0, vkSum: 0, bedienSum: 0, status: 'locked', gesamtUmsatzBruttoSum: 0, angepassterSollUmsatzSum: 0 };

        const totalCount = hj1Metrics.count + hj2Metrics.count;
        if (totalCount > 0) {
            const avgEff = (hj1Metrics.effSum + hj2Metrics.effSum) / totalCount;
            const avgAuslastung = (hj1Metrics.auslastungSum + hj2Metrics.auslastungSum) / totalCount;
            const avgVkFaktor = safeDiv((hj1Metrics.vkSum + hj2Metrics.vkSum), (hj1Metrics.bedienSum + hj2Metrics.bedienSum));
            const avgDeltaNetto = (hj1Metrics.deltaNettoSum + hj2Metrics.deltaNettoSum) / totalCount;
            
            const totalGesamtUmsatzBrutto = hj1Metrics.gesamtUmsatzBruttoSum + hj2Metrics.gesamtUmsatzBruttoSum;
            const totalAngepassterSoll = hj1Metrics.angepassterSollUmsatzSum + hj2Metrics.angepassterSollUmsatzSum;
            
            const avgGesamtUmsatzBrutto = totalGesamtUmsatzBrutto / totalCount;
            const avgAngepassterSoll = totalAngepassterSoll / totalCount;
            const avgAngepassterSollNetto = avgAngepassterSoll / vatMult;

            let personalStatusText = '🔴 Unter Kostendeckung';
            let personalStatusColor = 'text-red-500';
            if (avgGesamtUmsatzBrutto >= avgAngepassterSoll) {
                personalStatusText = '🟢 Ziel übertroffen';
                personalStatusColor = 'text-emerald-500';
            } else if (avgGesamtUmsatzBrutto >= kostendeckungsumsatz) {
                personalStatusText = '🟡 Kostendeckend';
                personalStatusColor = 'text-yellow-500';
            }

            const prozentDelta = avgAngepassterSollNetto > 0 ? (avgDeltaNetto / avgAngepassterSollNetto) * 100 : 0;

            realEmployees.push({
                id: maData.id,
                name: maData.name,
                isChef: false,
                effizienz: avgEff,
                auslastung: avgAuslastung / 100, 
                vk: avgVkFaktor,
                krank: hj1Metrics.krank + hj2Metrics.krank,
                urlaub: hj1Metrics.urlaub + hj2Metrics.urlaub,
                hj1: hj1Metrics.status,
                hj2: hj2Metrics.status,
                bonusHj1: hj1Metrics.count > 0 ? (hj1Metrics.bonusSum / 6) : 0, 
                bonusHj2: hj2Metrics.count > 0 ? (hj2Metrics.bonusSum / 6) : 0, 
                hasHj2: calc.clientData?.isHJ2Freigegeben,
                deltaNetto: avgDeltaNetto,
                personalStatusText,
                personalStatusColor,
                prozentDelta
            });
        }
    });

    // 💉 CHIRURGIE: MULTI-FOUNDER INTEGRATION FÜR DAS COCKPIT
    const isMultiFounder = calc.clientData?.personengesellschaft?.aktiv === true;
    const partnerData = calc.clientData?.personengesellschaft?.partner || [];

    if (isMultiFounder && partnerData.length > 0) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        partnerData.forEach((p: any) => {
            let bedienSum = 0;
            let vkSum = 0;
            let krankSum = 0;
            let urlaubSum = 0;
            let effSum = 0;
            let auslastungSum = 0;
            let count = 0;
            let deltaNettoSum = 0;

            const pWochenstunden = p.prodWochenstunden || 0;
            const pArbeitstageWoche = p.prodWochentage || 1;
            const pMonatsstunden = pWochenstunden * wochensatz;
            const pTagesArbeitszeit = pWochenstunden / pArbeitstageWoche;
            
            let expectedBrutto = p.durchschnittsumsatz || 0;
            if (expectedBrutto === 0) {
                const activeMonths = (p.monatsUmsaetze || []).filter((m: number) => m > 0);
                expectedBrutto = activeMonths.length > 0 ? activeMonths.reduce((a: number,b: number)=>a+b,0)/activeMonths.length : 0;
            }
            const sollumsatzPStd = pMonatsstunden > 0 ? expectedBrutto / pMonatsstunden : 0;
            const auslVorgabeDecimal = auslastungsVorgabe / 100;

            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const processPartnerHj = (hj: any[]) => {
                if (!Array.isArray(hj)) return;
                
                let summeIstUmsatz = 0, anzahlMonateMitUmsatz = 0;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                hj.forEach((m: any) => {
                    const bedien = getSafeVal(m, 'bedienumsatzBrutto', 'bedienUmsatz');
                    const vk = getSafeVal(m, 'vkUmsatzBrutto', 'vkUmsatz');
                    if ((bedien + vk) > 0) {
                        summeIstUmsatz += (bedien + vk);
                        anzahlMonateMitUmsatz++;
                    }
                });
                const avgIstUmsatzMonat = anzahlMonateMitUmsatz > 0 ? summeIstUmsatz / anzahlMonateMitUmsatz : 0;
                const avgIstUmsatzProStunde = safeDiv(avgIstUmsatzMonat, pMonatsstunden);

                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                hj.forEach((m: any) => {
                    const b = getSafeVal(m, 'bedienumsatzBrutto', 'bedienUmsatz');
                    const v = getSafeVal(m, 'vkUmsatzBrutto', 'vkUmsatz');
                    const gesamtIst = b + v;

                    if (gesamtIst > 0 || m.festmachen) {
                        krankSum += (Number(m.krankheitsTage) || 0);
                        urlaubSum += (Number(m.urlaubsTage) || 0);
                    }
                    
                    if (gesamtIst > 0) {
                        count++;
                        bedienSum += b;
                        vkSum += v;

                        const uTage = Number(m.urlaubsTage) || 0;
                        const urlaubsAusgleich = avgIstUmsatzProStunde * uTage * pTagesArbeitszeit;
                        const gesamtUmsatzBrutto = gesamtIst + urlaubsAusgleich;
                        
                        if (expectedBrutto > 0) effSum += gesamtUmsatzBrutto / expectedBrutto;
                        
                        const umsatzProStunde = safeDiv(gesamtUmsatzBrutto, pMonatsstunden);
                        if (sollumsatzPStd > 0) auslastungSum += (umsatzProStunde / sollumsatzPStd) * auslVorgabeDecimal;

                        const deltaBrutto = gesamtUmsatzBrutto - expectedBrutto;
                        deltaNettoSum += (deltaBrutto / vatMult);
                    }
                });
            };

            processPartnerHj(p.ulHalbjahr1);
            if (calc.clientData?.isHJ2Freigegeben) {
                processPartnerHj(p.ulHalbjahr2);
            }

            const pEffizienz = count > 0 ? effSum / count : 0;
            const pVkFaktor = bedienSum > 0 ? vkSum / bedienSum : 0;
            const pAuslastung = count > 0 ? auslastungSum / count : 0;
            const pAvgDeltaNetto = count > 0 ? deltaNettoSum / count : 0;

            const pAvgGesamtBrutto = count > 0 ? (bedienSum + vkSum) / count : 0;
            const pSollNetto = expectedBrutto / vatMult;

            const pEntnahme = p.entnahme || 0;
            const pSozial = p.sozialkosten || 0;
            const pKostendeckung = (pEntnahme + pSozial) * (calc.lohnfaktorData?.kostendeckungsfaktor1 || 2.8);

            let personalStatusText = '🔴 Unter Kostendeckung';
            let personalStatusColor = 'text-red-500';
            if (pAvgGesamtBrutto >= expectedBrutto && expectedBrutto > 0) {
                personalStatusText = '🟢 Ziel übertroffen';
                personalStatusColor = 'text-emerald-500';
            } else if (pAvgGesamtBrutto >= pKostendeckung) {
                personalStatusText = '🟡 Kostendeckend';
                personalStatusColor = 'text-yellow-500';
            }

            const pProzentDelta = pSollNetto > 0 ? (pAvgDeltaNetto / pSollNetto) * 100 : 0;

            realEmployees.push({
                id: p.id,
                name: p.name || 'Partner',
                isChef: true,
                effizienz: pEffizienz,
                auslastung: pAuslastung,
                vk: pVkFaktor,
                krank: krankSum,
                urlaub: urlaubSum,
                hj1: 'none', 
                hj2: 'none',
                bonusHj1: 0,
                bonusHj2: 0,
                hasHj2: calc.clientData?.isHJ2Freigegeben,
                deltaNetto: pAvgDeltaNetto,
                personalStatusText,
                personalStatusColor,
                prozentDelta: pProzentDelta
            });
        });
    } else {
        // ORIGINAL CHEF LOGIK
        if (calc.unternehmerMetrics?.efficiency > 0 || (calc.processedULHJ1?.summary?.gesamtumsatzBrutto > 0)) {
            const chefHj1 = calc.processedULHJ1;
            const chefHj2 = calc.processedULHJ2;
            
            let chefKrank = 0; let chefUrlaub = 0;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (calc.clientData?.ulHalbjahr1 || []).forEach((m: any, i: number) => {
                if (i < 6) { chefKrank += Number(m.krankheitsTage) || 0; chefUrlaub += Number(m.urlaubsTage) || 0; }
            });
            if (calc.clientData?.isHJ2Freigegeben) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (calc.clientData?.ulHalbjahr2 || []).forEach((m: any, i: number) => {
                    if (i < 6) { chefKrank += Number(m.krankheitsTage) || 0; chefUrlaub += Number(m.urlaubsTage) || 0; }
                });
            }
            
            const chefIst = (chefHj1?.summary?.gesamtumsatzBrutto || 0) + (calc.clientData?.isHJ2Freigegeben ? (chefHj2?.summary?.gesamtumsatzBrutto || 0) : 0);
            const chefSoll = (chefHj1?.summary?.activePlanumsatz || 0) + (calc.clientData?.isHJ2Freigegeben ? (chefHj2?.summary?.activePlanumsatz || 0) : 0);
            const chefKostendeckung = (chefHj1?.summary?.activeKostendeckung || 0) + (calc.clientData?.isHJ2Freigegeben ? (chefHj2?.summary?.activeKostendeckung || 0) : 0);
            
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const chefMonths = (chefHj1?.monatsDetails?.filter((m:any) => m.hasUmsatz).length || 0) + (calc.clientData?.isHJ2Freigegeben ? (chefHj2?.monatsDetails?.filter((m:any) => m.hasUmsatz).length || 0) : 0) || 1;

            const avgChefIst = chefIst / chefMonths;
            const avgChefSoll = chefSoll / chefMonths;
            const avgChefKostendeckung = chefKostendeckung / chefMonths;
            const avgChefSollNetto = avgChefSoll / vatMult;
            
            let personalStatusText = '🔴 Unter Kostendeckung';
            let personalStatusColor = 'text-red-500';
            if (avgChefIst >= avgChefSoll) {
                personalStatusText = '🟢 Ziel übertroffen';
                personalStatusColor = 'text-emerald-500';
            } else if (avgChefIst >= avgChefKostendeckung) {
                personalStatusText = '🟡 Kostendeckend';
                personalStatusColor = 'text-yellow-500';
            }

            const chefDeltaNetto = (avgChefIst - avgChefSoll) / vatMult;
            const chefProzentDelta = avgChefSollNetto > 0 ? (chefDeltaNetto / avgChefSollNetto) * 100 : 0;

            const safeDecimal = (val: number) => val > 2 ? val / 100 : val;

            realEmployees.push({
                id: 'chef',
                name: calc.clientData?.unternehmername || 'Inhaber/in',
                isChef: true,
                effizienz: safeDecimal(calc.unternehmerMetrics?.efficiency || 0),
                auslastung: safeDecimal(calc.unternehmerMetrics?.umsatzauslastung || 0), 
                vk: safeDecimal(calc.unternehmerMetrics?.vkFaktor || 0),
                krank: chefKrank,
                urlaub: chefUrlaub,
                hj1: 'none', 
                hj2: 'none',
                bonusHj1: 0,
                bonusHj2: 0,
                hasHj2: calc.clientData?.isHJ2Freigegeben,
                deltaNetto: chefDeltaNetto,
                personalStatusText,
                personalStatusColor,
                prozentDelta: chefProzentDelta
            });
        }
    }

    let sumEffizienz = 0; 
    let countEffizienz = 0;
    let totalKrank = 0;
    let totalUrlaub = 0;

    realEmployees.forEach((emp) => {
        totalKrank += emp.krank;
        totalUrlaub += emp.urlaub;
        if (emp.effizienz > 0) {
            sumEffizienz += emp.effizienz;
            countEffizienz++;
        }
    });

    const globalEffizienz = countEffizienz > 0 ? sumEffizienz / countEffizienz : 0;
    const ausfallKostenVerlust = totalKrank * (calc.durchschnittlicherUmsatzProTag || 0) * (auslastungsVorgabe / 100);

    // ========================================================================
    // CEO-BOX STATUS LOGIK
    // ========================================================================
    const nettoKosten = avgSollNetto;
    const nettoIst = avgGesamtNetto;
    const istRuecklagenEur = nettoIst - nettoKosten;
    const isProfitabel = istRuecklagenEur >= 0;
    const zielRuecklagenEur = nettoKosten * ruecklagenZielFaktor;
    const isUeberZiel = (istRuecklagenEur - zielRuecklagenEur) >= 0;

    let hintConfig = {
        title: 'PERFORMANCE EXZELLENT',
        text: 'Das Umsatzziel wurde voll übertroffen. Hochprofitabel.',
        color: 'text-emerald-400',
        border: 'border-emerald-500/30',
        icon: ThumbsUp
    };

    if (!isProfitabel) {
        hintConfig = {
            title: 'LEISTUNGSHINWEIS',
            text: 'Der Umsatz reicht nicht zur vollständigen Kostendeckung aus.',
            color: 'text-red-400',
            border: 'border-red-500/40 shadow-[0_0_15px_rgba(239,68,68,0.2)]',
            icon: AlertTriangle
        };
    } else if (!isUeberZiel) {
         hintConfig = {
            title: 'KOSTENDECKEND',
            text: `Fixkosten sind gedeckt, strategisches Ziel von ${ruecklagenZielFaktor * 100}% jedoch noch offen.`,
            color: 'text-amber-400',
            border: 'border-amber-500/30',
            icon: ShieldCheck
        };
    }

    // ========================================================================
    // DATA-BINDING SCHRITT 4: CHART (IST-UMSATZ VERLAUF)
    // ========================================================================
    const rawChartData = calc.clientData?.gesamtleistungData || Array(12).fill({});
    
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const realChart = rawChartData.slice(0, 12).map((monat: any, index: number) => {
        const bedien = parseVal(monat.bedienumsatzBrutto ?? monat.bedienUmsatz);
        const vk = parseVal(monat.vkUmsatzBrutto ?? monat.vkUmsatz);
        const gesamtBrutto = bedien + vk;
        
        const isLocked = monat.abgeschlossen === true;
        const snap = monat.frozenCalculations || {};

        const currentBaseMindestumsatz = index < 6 ? m1 : m2;
        const activeMindestumsatzBase = (isLocked && snap.mindestumsatzBase !== undefined) ? parseVal(snap.mindestumsatzBase) : currentBaseMindestumsatz;
        const activeMwstFaktor = (isLocked && snap.mwstFaktor !== undefined) ? parseVal(snap.mwstFaktor) : vatMult;

        const anpassung = monat.kostenErhoeht ? -1 : 1;
        const angepassterSollNetto = activeMindestumsatzBase + (parseVal(monat.aussergewoehnlich) * anpassung);
        
        const gesamtNetto = safeDiv(gesamtBrutto, activeMwstFaktor);
        
        const ruecklagenDeltaNetto = gesamtNetto - angepassterSollNetto;
        const prozent = angepassterSollNetto > 0 ? (ruecklagenDeltaNetto / angepassterSollNetto) * 100 : 0;

        const hasData = gesamtBrutto > 0 || monat.abgeschlossen || monat.festmachen || monat.isLocked;

        return {
            month: ['JAN', 'FEB', 'MAR', 'APR', 'MAI', 'JUN', 'JUL', 'AUG', 'SEP', 'OKT', 'NOV', 'DEZ'][index],
            bedien: bedien,
            vk: vk,
            vkFaktor: bedien > 0 ? (vk / bedien) * 100 : 0,
            deltaNetto: hasData ? ruecklagenDeltaNetto : 0,
            prozent: hasData ? prozent : 0,
            hasData
        };
    });

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const activeChartMonths = realChart.filter((m: any) => m.hasData);
    if (activeChartMonths.length > 0) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const sumBedien = activeChartMonths.reduce((s: number, m: any) => s + m.bedien, 0);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const sumVk = activeChartMonths.reduce((s: number, m: any) => s + m.vk, 0);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const sumDeltaNetto = activeChartMonths.reduce((s: number, m: any) => s + m.deltaNetto, 0);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const sumProzent = activeChartMonths.reduce((s: number, m: any) => s + m.prozent, 0);

        const activeAvgBedien = sumBedien / activeChartMonths.length;
        const activeAvgVk = sumVk / activeChartMonths.length;

        realChart.push({
            month: 'Ø',
            bedien: activeAvgBedien,
            vk: activeAvgVk,
            vkFaktor: activeAvgBedien > 0 ? (activeAvgVk / activeAvgBedien) * 100 : 0,
            deltaNetto: sumDeltaNetto / activeChartMonths.length,
            prozent: sumProzent / activeChartMonths.length,
            hasData: true
        });
    } else {
        realChart.push({ month: 'Ø', bedien: 0, vk: 0, vkFaktor: 0, deltaNetto: 0, prozent: 0, hasData: false });
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const maxChartValue = Math.max(...realChart.map((m: any) => Math.max(m.bedien, m.vk))) * 1.15 || 1000;

    return (
        <div className="min-h-screen bg-deep-space p-4 sm:p-8 text-slate-200 font-sans selection:bg-phantom-gold selection:text-black pb-24">
            <DashboardStyles />
            
            <div className="max-w-[1380px] mx-auto mb-8 sticky top-0 md:top-28 z-30">
                <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 border border-pe-border dark:border-[#2a2a2a] carbon-weave-bg bg-pe-card/95 dark:bg-[#0a0a0a]/95 backdrop-blur-md shadow-lg rounded-xl p-5">
                    <div>
                        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-black text-pe-text tracking-tighter uppercase drop-shadow-2xl flex flex-wrap items-center gap-2 sm:gap-4">Business <span className="text-phantom-gold">Cockpit</span></h1>
                        <p className="text-xs text-pe-muted font-bold tracking-[0.2em] uppercase mt-2">Professional Business Logic • Executive Console</p>
                    </div>
                    
                    <button 
                        type="button"
                        onClick={() => setIsAiModalOpen(true)}
                        className="group relative shrink-0 flex items-center gap-3 bg-pe-card dark:bg-black border border-phantom-gold/30 hover:border-phantom-gold/80 px-6 py-3 rounded-xl shadow-[0_0_20px_rgba(230,194,153,0.1)] hover:shadow-[0_0_30px_rgba(230,194,153,0.25)] transition-all overflow-hidden"
                    >
                        <div className="absolute inset-0 bg-gradient-to-r from-phantom-gold/0 via-phantom-gold/10 to-phantom-gold/0 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000"></div>
                        <Bot className="w-5 h-5 text-phantom-gold led-gold relative z-10" />
                        <span className="font-bold text-xs uppercase tracking-widest text-phantom-gold relative z-10">KI-Diagnose anfordern</span>
                    </button>
                </div>
            </div>

            <div className="max-w-[1380px] mx-auto flex flex-col gap-12">
                
                {/* =========================================================
                    1. PRICING & TAKTUNGS-MATRIX 
                ========================================================= */}
                <div className="carbon-console carbon-console--split flex flex-col">
                    <div className="carbon-console__head carbon-weave-bg carbon-content flex items-center gap-4 border-b border-pe-border-strong"><Gauge className="w-5 h-5 text-phantom-gold" /><h2 className="text-xl lg:text-3xl font-bold text-pe-text tracking-widest uppercase">Pricing & Taktungs-Matrix</h2></div>
                    <div className="carbon-console__body carbon-content grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-y-12 lg:gap-0 divide-y lg:divide-y-0 lg:divide-x divide-[#333]">
                        <div className="flex flex-col items-center pt-8 lg:pt-0"><CarbonSpeedometer label="Satz ohne Material (Brutto)" actual={tacho1Actual} recommended={tacho1Recommended} maxScale={120} currency={currency} sollMargin={basisRuecklage} istMargin={istMargin1} /></div>
                        <div className="flex flex-col items-center pt-8 lg:pt-0"><CarbonSpeedometer label="Satz inkl. Material (Brutto)" actual={tacho2Actual} recommended={tacho2Recommended} maxScale={160} currency={currency} sollMargin={targetMatRuecklage} istMargin={istMargin2} /></div>
                        <div className="flex flex-col items-center pt-8 lg:pt-0"><BarometerTool title="Chrono-Barometer (Zeit)" icon={Clock} actualBase={tacho1Actual} recommendedBase={tacho1Recommended} currency={currency} /></div>
                        <div className="flex flex-col items-center pt-8 lg:pt-0"><BarometerTool title="Ressourcen-Barometer (Material)" icon={Box} actualBase={tacho2Actual} recommendedBase={tacho2Recommended} isMaterial={true} currency={currency} /></div>
                    </div>
                </div>

                {/* =========================================================
                    2. CEO FINANZ-MATRIX
                ========================================================= */}
                <CEOFinanzMatrix 
                    nettoKosten={nettoKosten} 
                    nettoIst={nettoIst} 
                    vatMult={vatMult} 
                    ruecklagenZielFaktor={ruecklagenZielFaktor}
                    currency={currency} 
                    wochensatz={wochensatz}
                    oeffnungstage={oeffnungstage}
                    oeffnungsstunden={oeffnungsstunden}
                />

                {/* =========================================================
                    3. UNTERNEHMENS-GESAMTWERTE (HEALTH & ABSENZEN)
                ========================================================= */}
                <div className="flex flex-col gap-6">
                    <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
                        {[
                            { label: "Ø Team-Effizienz", val: globalEffizienz, fmt: (v:number) => (v*100).toFixed(1), type: 'effizienz', icon: Zap, isTeamData: true },
                            { label: "Ø Umsatzauslastung", val: globalAuslastungDecimal, fmt: (v:number) => (v*100).toFixed(1), type: 'auslastung', icon: Activity },
                            { label: "Verkaufsfaktor", val: globalVkFaktor, fmt: (v:number) => (v*100).toFixed(1), type: 'vk', icon: TrendingUp },
                            { label: "Reale Rentabilität", val: realeRentabilitaet, fmt: (v:number) => (v*100).toFixed(1), type: 'rentabilitaet', icon: ShieldCheck, highlight: true }
                        ].map((metric, i) => {
                            if (metric.isTeamData && !showTeamData) return null;
                            
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            const status = getHealthStatus(metric.val, metric.type as any, gehalt, ueberschussProzent);
                            return (
                                <div key={i} className={`carbon-panel carbon-weave-bg p-6 flex flex-col h-full ${metric.highlight ? 'border-b-4 border-b-phantom-gold' : ''}`}>
                                    <div className="flex flex-col items-center justify-center flex-grow text-center">
                                        <metric.icon className="w-6 h-6 text-[#555] mb-4 carbon-content" />
                                        <span className="carbon-content text-xs font-semibold text-pe-muted uppercase tracking-wider mb-3">{metric.label}</span>
                                        <span className={`carbon-content text-4xl font-black font-mono-numbers mb-2 ${status.colorClass}`}>{metric.fmt(metric.val)}<span className="text-lg opacity-50">%</span></span>
                                        <span className={`carbon-content text-[8px] lg:text-[9px] font-bold uppercase tracking-widest px-2 py-1 rounded border ${status.badgeClass}`}>{status.label}</span>
                                    </div>
                                    
                                    {/* 💉 NEU: Erklärungstext in der Kachel */}
                                    {status.text && (
                                        <div className="carbon-content w-full mt-4 pt-3 border-t border-pe-border-strong text-center">
                                            <p className={`text-[10px] font-sans leading-relaxed ${status.colorClass.replace(/led-[a-z]+/, '').trim()}`}>
                                                {status.text}
                                            </p>
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                    
                    {showTeamData && (
                        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 mt-6">
                            <div className="carbon-panel carbon-weave-bg p-6 flex flex-col items-center justify-between text-center shadow-md">
                                <div className="flex items-center justify-center gap-3 mb-2 carbon-content"><Calendar className="text-amber-400 w-5 h-5" /><span className="text-[10px] font-bold text-amber-400 uppercase tracking-widest">Urlaubstage (Team)</span></div>
                                <div className="text-4xl font-black font-mono-numbers led-amber mt-2 carbon-content flex items-baseline justify-center gap-2">{fmt(totalUrlaub)} <span className="text-sm font-sans font-bold text-amber-500/50">Tage</span></div>
                                <span className="carbon-content w-full text-center text-[9px] text-pe-muted font-bold uppercase tracking-widest mt-4 border-t border-pe-border-strong pt-3">Geplanter & genommener Urlaub</span>
                            </div>

                            <div className="carbon-panel carbon-weave-bg p-6 flex flex-col items-center justify-between text-center shadow-md">
                                <div className="flex items-center justify-center gap-3 mb-2 carbon-content"><Stethoscope className="text-red-400 w-5 h-5" /><span className="text-[10px] font-bold text-red-400 uppercase tracking-widest">Krankheitstage (Team)</span></div>
                                <div className="text-4xl font-black font-mono-numbers led-red mt-2 carbon-content flex items-baseline justify-center gap-2">{fmt(totalKrank)} <span className="text-sm font-sans font-bold text-red-500/50">Tage</span></div>
                                <span className="carbon-content w-full text-center text-[9px] text-pe-muted font-bold uppercase tracking-widest mt-4 border-t border-pe-border-strong pt-3">Gesamter Zeitraum</span>
                            </div>
                            
                            <div className="carbon-panel carbon-weave-bg p-6 flex flex-col items-center justify-between text-center border border-red-900/30 shadow-md">
                                <div className="flex items-center justify-center gap-3 mb-2 carbon-content"><TrendingDown className="text-red-500 w-5 h-5" /><span className="text-[10px] font-bold text-red-500 uppercase tracking-widest">Ø Umsatzverlust (Krankheit)</span></div>
                                <div className="text-4xl font-black font-mono-numbers led-red mt-2 carbon-content flex items-baseline justify-center gap-2">-{fmt(ausfallKostenVerlust)} <span className="text-sm font-sans font-bold text-red-500/50">{currency}</span></div>
                                <span className="carbon-content w-full text-center text-[9px] text-pe-muted font-bold uppercase tracking-widest mt-4 border-t border-pe-border-strong pt-3">Kalkulatorischer Ausfall</span>
                            </div>

                            <div className={`carbon-panel carbon-weave-bg p-6 flex flex-col justify-between text-center border ${hintConfig?.border || 'border-slate-500'}`}>
                                <div className="flex items-center justify-center gap-3 mb-2 carbon-content">
                                    {hintConfig?.icon && <hintConfig.icon className={`w-5 h-5 ${hintConfig?.color || 'text-pe-muted'}`} />}
                                    <span className={`text-[10px] font-bold uppercase tracking-widest ${hintConfig?.color || 'text-pe-muted'}`}>
                                        Team-Status
                                    </span>
                                </div>
                                <div className={`text-sm lg:text-base font-black uppercase tracking-wider mt-3 carbon-content ${hintConfig?.color || 'text-pe-muted'}`}>
                                    {hintConfig?.title || 'System Status'}
                                </div>
                                <span className="carbon-content w-full text-center text-[10px] text-pe-muted font-medium leading-relaxed mt-4 border-t border-pe-border-strong pt-3">
                                    {hintConfig?.text || 'Bereit für Analyse.'}
                                </span>
                            </div>
                        </div>
                    )}
                </div>

                {/* =========================================================
                    4. IST-UMSATZ VERLAUF (DAS DIAGRAMM)
                ========================================================= */}
                <div className="carbon-panel carbon-panel--split w-full flex flex-col overflow-hidden">
                    <div className="carbon-panel__head carbon-weave-bg carbon-content flex flex-col sm:flex-row justify-between items-start sm:items-center border-b border-pe-border-strong gap-6">
                        <div className="flex items-center gap-4">
                            <div className="metal-badge p-3"><BarChart2 className="w-6 h-6 text-phantom-gold" /></div>
                            <div>
                                <h2 className="text-xl lg:text-3xl font-bold text-pe-text tracking-widest uppercase">Ist-Umsatz Verlauf</h2>
                                <p className="text-xs text-pe-muted font-bold uppercase tracking-[0.15em] mt-1">Bedienung vs. Verkauf (Brutto) • 12+1 Matrix</p>
                            </div>
                        </div>
                        <div className="flex gap-4 lg:gap-6 text-[9px] lg:text-[10px] font-bold uppercase tracking-widest text-pe-muted metal-badge dark:bg-black/50 px-4 lg:px-6 py-2 lg:py-3 overflow-x-auto whitespace-nowrap">
                            <span className="flex items-center gap-2 lg:gap-3"><div className="w-3 h-3 rounded-sm bg-gradient-to-r from-[#444] to-[#2a2a2a] border border-[#888]"></div> Bedienung</span>
                            <span className="flex items-center gap-2 lg:gap-3"><div className="w-3 h-3 rounded-sm bg-gradient-to-r from-[#b48a56] to-[#E6C299] border border-[#fff]"></div> Verkauf</span>
                            <span className="flex items-center gap-2 lg:gap-3 ml-2 lg:ml-4 border-l border-slate-700 pl-4 lg:pl-6"><div className="w-3 h-3 rounded-sm bg-emerald-900/50 border border-emerald-500/50"></div> Rücklage (Netto)</span>
                        </div>
                    </div>

                    <div className="carbon-panel__body carbon-content w-full h-[500px] flex flex-col relative">
                        <div className="absolute inset-0 flex flex-col justify-between pointer-events-none opacity-20 py-24 z-0">
                            {[1, 2, 3].map(i => <div key={i} className="border-b border-[#555] w-full border-dashed"></div>)}
                        </div>

                        <div className="flex-grow flex justify-between h-full z-10 w-full">
                            {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
                            {realChart.map((data: any, idx: number) => {
                                const hBedien = (data.bedien / maxChartValue) * 100 || 0;
                                const hVk = (data.vk / maxChartValue) * 100 || 0;
                                const isAvg = data.month === 'Ø';
                                
                                const zielProzent = ruecklagenZielFaktor * 100;
                                let topBadgeColor = '';
                                let topBadgeText = '';
                                let topBadgeSubText = '';
                                let topBadgeShadow = '';

                                if (data.prozent < 0) {
                                    topBadgeColor = 'bg-red-950/20 border-red-500/30';
                                    topBadgeText = 'text-red-400';
                                    topBadgeSubText = 'text-red-500';
                                    topBadgeShadow = 'shadow-[0_0_15px_rgba(239,68,68,0.15)]';
                                } else if (data.prozent < zielProzent) {
                                    topBadgeColor = 'bg-amber-950/20 border-amber-500/30';
                                    topBadgeText = 'text-amber-400';
                                    topBadgeSubText = 'text-amber-500';
                                    topBadgeShadow = 'shadow-[0_0_15px_rgba(245,158,11,0.15)]';
                                } else {
                                    topBadgeColor = 'bg-emerald-950/20 border-emerald-500/40';
                                    topBadgeText = 'text-emerald-400';
                                    topBadgeSubText = 'text-emerald-500';
                                    topBadgeShadow = 'shadow-[0_0_15px_rgba(16,185,129,0.15)]';
                                }
                                
                                let vkBadgeColor = '';
                                if (data.vkFaktor >= 10) {
                                    vkBadgeColor = 'text-emerald-400 bg-emerald-950/40 border-emerald-500/30';
                                } else if (data.vkFaktor >= 5) {
                                    vkBadgeColor = 'text-amber-400 bg-amber-950/40 border-amber-500/30';
                                } else {
                                    vkBadgeColor = 'text-red-400 bg-red-950/40 border-red-500/30';
                                }

                                return (
                                    <div key={idx} className={`flex-1 flex flex-col h-full ${isAvg ? 'border-l border-pe-border-strong ml-1 pl-1 lg:ml-2 lg:pl-2' : ''}`}>
                                        
                                        {/* TOP BADGE: Netto + Prozente + Micro-Typo */}
                                        <div className="h-24 flex items-center justify-center pb-2">
                                            {data.hasData && (
                                                <div className={`flex flex-col items-center justify-center p-2 lg:p-3 rounded-xl border tracking-tighter w-16 lg:w-[4.5rem] h-16 lg:h-20 ${topBadgeColor} ${topBadgeShadow}`}>
                                                    <span className={`text-[12px] lg:text-[15px] xl:text-[18px] font-black font-mono-numbers leading-none ${topBadgeText}`}>
                                                        {data.deltaNetto > 0 ? '+' : ''}{fmt(data.deltaNetto)}
                                                    </span>
                                                    <span className={`text-[9px] lg:text-[10px] xl:text-[11px] font-bold font-mono-numbers mt-1.5 leading-none opacity-80 ${topBadgeSubText}`}>
                                                        {formatDynamicPercent(data.prozent)}
                                                    </span>
                                                    <span className={`text-[8px] lg:text-[9px] font-bold uppercase tracking-widest mt-1.5 opacity-60 ${topBadgeText}`}>
                                                        Rücklage
                                                    </span>
                                                </div>
                                            )}
                                        </div>

                                        {/* BARS */}
                                        <div className="flex-grow flex items-end justify-center gap-1 border-b-2 border-[#444] pb-0 pt-8 relative px-0.5">
                                            <div className="w-[45%] max-w-[40px] relative flex flex-col justify-end" style={{ height: `${hBedien}%` }}>
                                                {data.hasData && (
                                                    <span className="absolute -top-7 w-full flex justify-center z-20">
                                                        <span className="bg-black/60 px-1 py-0.5 rounded text-[9px] lg:text-[11px] xl:text-[13px] font-black font-mono-numbers text-white shadow-lg tracking-tighter">
                                                            {fmt(data.bedien)}
                                                        </span>
                                                    </span>
                                                )}
                                                <div className="w-full h-full bar-monolith-bedienung"></div>
                                            </div>
                                            <div className="w-[45%] max-w-[40px] relative flex flex-col justify-end" style={{ height: `${hVk}%` }}>
                                                {data.hasData && (
                                                    <span className="absolute -top-7 w-full flex justify-center z-20">
                                                        <span className="bg-black/60 px-1 py-0.5 rounded text-[9px] lg:text-[11px] xl:text-[13px] font-black font-mono-numbers text-phantom-gold shadow-lg tracking-tighter">
                                                            {fmt(data.vk)}
                                                        </span>
                                                    </span>
                                                )}
                                                <div className="w-full h-full bar-monolith-verkauf"></div>
                                            </div>
                                        </div>

                                        {/* BOTTOM BADGE: VK-FAKTOR (Zweizeilig) */}
                                        <div className="h-16 flex flex-col items-center justify-start pt-3 gap-1.5">
                                            <span className={`text-[10px] lg:text-[12px] xl:text-[14px] font-black uppercase tracking-widest px-2 lg:px-4 py-1.5 rounded-md shadow-lg ${isAvg ? 'text-phantom-gold metal-badge dark:bg-[#111]' : 'text-pe-muted dark:text-slate-300 bg-pe-tile-header dark:bg-black/60 border border-pe-border-strong'}`}>
                                                {data.month}
                                            </span>
                                            {data.hasData && (
                                                <div className={`flex flex-col items-center justify-center px-2 py-1 rounded-md border mt-1 ${vkBadgeColor}`}>
                                                    <span className="text-[8px] lg:text-[9px] uppercase tracking-widest opacity-70 mb-0.5">VK-Faktor</span>
                                                    <span className="text-[9px] lg:text-[10px] xl:text-[11px] font-black font-mono-numbers leading-none whitespace-nowrap">
                                                        {formatVkPercent(data.vkFaktor)}
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>

                {/* =========================================================
                    5. TEAM TELEMETRIE
                ========================================================= */}
                {showTeamData && (
                    <div className="carbon-panel carbon-panel--split w-full flex flex-col overflow-hidden">
                        <div className="carbon-panel__head carbon-weave-bg carbon-content flex items-center gap-4 border-b border-pe-border-strong">
                            <div className="metal-badge p-3"><Users className="w-6 h-6 text-phantom-gold" /></div>
                            <div>
                                <h2 className="text-xl lg:text-3xl font-bold text-pe-text tracking-widest uppercase">Team Telemetrie</h2>
                                <p className="text-xs text-pe-muted font-bold uppercase tracking-[0.15em] mt-1">
                                    {isTeamMode
                                        ? 'Performance + Team-Bonus-Vorschau (kein Einzel-Leistungslohn)'
                                        : 'Lineare Performance-Akte der produktiven Kräfte (Ø Monat)'}
                                </p>
                            </div>
                        </div>

                        <div className="carbon-panel__body carbon-content w-full overflow-x-auto pb-4">
                            <div className="min-w-[1100px]">
                                
                                {/* Header Row */}
                                <div className="flex items-end gap-4 border-b-2 border-pe-border-strong pb-3 mb-4 px-4 text-[10px] font-black uppercase tracking-widest text-pe-muted text-center">
                                    <div className="w-[18%] text-left">Mitarbeiter</div>
                                    <div className="w-[11%]">Ø Effizienz</div>
                                    <div className="w-[10%]">VK-Faktor</div>
                                    <div className="w-[11%] flex flex-col items-center">
                                        <span>Ø Auslastung</span>
                                        <span className="text-[8px] normal-case text-slate-600">(Umsatz)</span>
                                    </div>
                                    <div className="w-[12%]">Krank / Urlaub</div>
                                    <div className="w-[8%]">1. Hj. | 2. Hj.</div>
                                    <div className="w-[12%] flex flex-col items-center">
                                        <span>{isTeamMode ? 'Team-Bonus' : 'Bonus pro Monat'}</span>
                                        <span className="text-[8px] normal-case text-slate-600">
                                            1. Hj. | 2. Hj.
                                        </span>
                                    </div>
                                    <div className="w-[14%] text-right ml-auto">Überschuss (Netto)</div>
                                </div>

                                {/* Employee Rows */}
                                <div className="flex flex-col gap-3">
                                    {realEmployees.map((emp) => {
                                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                        const effStatus = getHealthStatus(emp.effizienz, 'effizienz' as any, gehalt, ueberschussProzent);
                                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                        const auslStatus = getHealthStatus(emp.auslastung, 'auslastung' as any, gehalt, ueberschussProzent);
                                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                        const vkStatus = getHealthStatus(emp.vk, 'vk' as any, gehalt, ueberschussProzent);
                                        const isProfit = emp.deltaNetto >= 0;

                                        return (
                                            <div key={emp.id} className={`flex items-center gap-4 p-4 rounded-xl transition-colors border ${emp.isChef ? 'bg-[#E6C299]/5 border-phantom-gold/30' : 'bg-pe-card dark:bg-black/40 border-pe-border dark:border-[#222] hover:bg-pe-hover dark:hover:bg-[#111]'}`}>
                                                
                                                {/* 1. Name & Status */}
                                                <div className="w-[18%] flex items-center gap-3 text-left">
                                                    <div className={`p-2 rounded-lg border shrink-0 ${emp.isChef ? 'bg-pe-card dark:bg-black border-phantom-gold text-phantom-gold shadow-[0_0_10px_rgba(230,194,153,0.3)]' : 'bg-pe-tile-header dark:bg-[#1a1a1a] border-pe-border-strong text-pe-muted'}`}>
                                                        <User className="w-4 h-4" />
                                                    </div>
                                                    <div className="flex flex-col">
                                                        <span className={`text-sm font-bold uppercase tracking-wider ${emp.isChef ? 'text-phantom-gold' : 'text-stone-900 dark:text-white'}`}>
                                                            {emp.name}
                                                        </span>
                                                        {!emp.isChef && (
                                                            <span className={`text-[9px] font-bold uppercase tracking-widest mt-0.5 ${emp.personalStatusColor}`}>
                                                                {emp.personalStatusText}
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>

                                                {/* 2. Effizienz */}
                                                <div className={`w-[11%] text-center font-mono-numbers text-base font-black ${effStatus.colorClass}`}>
                                                    {(emp.effizienz * 100).toFixed(1)}%
                                                </div>

                                                {/* 3. VK-Faktor */}
                                                <div className={`w-[10%] text-center font-mono-numbers text-base font-black ${vkStatus.colorClass}`}>
                                                    {(emp.vk * 100).toFixed(1)}%
                                                </div>

                                                {/* 4. Auslastung */}
                                                <div className={`w-[11%] text-center font-mono-numbers text-base font-black ${auslStatus.colorClass}`}>
                                                    {(emp.auslastung * 100).toFixed(1)}%
                                                </div>

                                                {/* 5. Krank / Urlaub */}
                                                <div className="w-[12%] flex items-center justify-center gap-5 text-center">
                                                    <div className="flex flex-col items-center">
                                                        <Stethoscope className="w-4 h-4 text-red-500/60 mb-1" />
                                                        <span className="text-[15px] font-bold font-mono-numbers text-red-400">{emp.krank}</span>
                                                    </div>
                                                    <div className="w-px h-8 bg-slate-700/50"></div>
                                                    <div className="flex flex-col items-center">
                                                        <Calendar className="w-4 h-4 text-amber-500/60 mb-1" />
                                                        <span className="text-[15px] font-bold font-mono-numbers text-amber-400">{emp.urlaub}</span>
                                                    </div>
                                                </div>

                                                {/* 6. Hj1 & Hj2 Ampeln */}
                                                <div className="w-[8%] text-center flex items-center justify-center gap-3">
                                                    <HjIcon status={emp.hj1} />
                                                    <span className="text-[#333]">|</span>
                                                    <HjIcon status={emp.hj2} />
                                                </div>

                                                {/* 7. Bonus */}
                                                <div className="w-[12%] text-center font-mono-numbers font-bold text-sm flex items-center justify-center gap-2">
                                                    {emp.isChef ? (
                                                        <span className="text-slate-600">—</span>
                                                    ) : isTeamMode ? (
                                                        (() => {
                                                            const id = String(emp.id || '');
                                                            const inTeam = selectedMemberIds.includes(id);
                                                            const mon = inTeam ? (Number(bonusById[id]) || 0) : 0;
                                                            const hj = mon * 6;
                                                            return (
                                                                <>
                                                                    <span className={mon > 0 ? 'text-amber-400' : 'text-slate-600'}>
                                                                        {mon > 0 ? '+' : ''}{fmt(mon)}
                                                                    </span>
                                                                    <span className="text-[#333]">|</span>
                                                                    {emp.hasHj2 ? (
                                                                        <span className={mon > 0 ? 'text-amber-400' : 'text-slate-600'}>
                                                                            {mon > 0 ? '+' : ''}{fmt(hj / 6)}
                                                                        </span>
                                                                    ) : (
                                                                        <Ban className="w-3 h-3 text-slate-700" />
                                                                    )}
                                                                </>
                                                            );
                                                        })()
                                                    ) : (
                                                        <>
                                                            <span className={emp.bonusHj1 >= 0 ? "text-emerald-400" : "text-red-400"}>
                                                                {emp.bonusHj1 > 0 ? '+' : ''}{fmt(emp.bonusHj1)}
                                                            </span>
                                                            <span className="text-[#333]">|</span>
                                                            {emp.hasHj2 ? (
                                                                <span className={emp.bonusHj2 >= 0 ? "text-emerald-400" : "text-red-400"}>
                                                                    {emp.bonusHj2 > 0 ? '+' : ''}{fmt(emp.bonusHj2)}
                                                                </span>
                                                            ) : (
                                                                <Ban className="w-3 h-3 text-slate-700" />
                                                            )}
                                                        </>
                                                    )}
                                                </div>

                                                {/* 8. Delta Netto + Prozent */}
                                                <div className="w-[14%] text-right ml-auto flex justify-end">
                                                    <div className={`metal-badge px-3 py-1.5 flex flex-col items-center justify-center gap-1 ${isProfit ? 'bg-emerald-950/20 border-emerald-500/30' : 'bg-red-950/20 border-red-500/30'}`}>
                                                        <span className={`text-base font-black font-mono-numbers leading-none ${isProfit ? 'led-emerald' : 'led-red'}`}>
                                                            {isProfit ? '+' : ''}{fmt(emp.deltaNetto)}
                                                        </span>
                                                        <span className={`text-[10px] font-bold font-mono-numbers opacity-80 leading-none ${isProfit ? 'text-emerald-500' : 'text-red-500'}`}>
                                                            {formatDynamicPercent(emp.prozentDelta)}
                                                        </span>
                                                    </div>
                                                </div>

                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>

                        {showTeamData && (
                            <div className="carbon-content mt-6 max-w-3xl">
                                <TeamBonusPreviewPanel
                                    currencySymbol={currency === 'CHF' ? 'CHF' : '€'}
                                    showIndividual
                                />
                            </div>
                        )}
                    </div>
                )}

                {/* =========================================================
                    6. KI-ANALYSE MODAL (INTEGRATION)
                ========================================================= */}
                <CockpitAiModal 
                    isOpen={isAiModalOpen} 
                    onClose={() => setIsAiModalOpen(false)} 
                    currencyCode={currency}
                    auslastungsVorgabe={auslastungsVorgabe}
                    ruecklagenZielFaktor={ruecklagenZielFaktor}
                    pricingData={{ stundenfaktor, echterStundensatz, targetMatPreis, echterStundensatzMat, basisRuecklage, targetMatRuecklage }}
                    ceoData={{ nettoKosten, nettoZiel, nettoIst: avgGesamtNetto }}
                    vitalsData={{ globalEffizienz, globalAuslastungDecimal, globalVkFaktor, realeRentabilitaet }}
                    teamData={{ realEmployees, totalKrank, totalUrlaub, ausfallKostenVerlust }}
                    hintConfig={hintConfig}
                />

            </div>
        </div>
    );
}